// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
	baseURL:
		| 'https://backend.staging.mopla.solutions'
		| 'https://backend.pullrequest.mopla.solutions/pr-{pullrequest-id}'
		| 'http://localhost:8080'
		| (string & {});
};

/**
 * an email will be sent to user that asks for email verification
 */
export type CommandPayloadVerifyEmail = {
	app: AppContext;
};

/**
 * App enum (PASSENGER or DRIVER allowed)
 */
export enum AppContext {
	DRIVER = 'DRIVER',
	PASSENGER = 'PASSENGER',
}

/**
 * payload specific for command 'updateZone'
 */
export type CommandPayloadUpdateZone = {
	/**
	 * The label of the zone
	 */
	label: string;
	/**
	 * Flag to set if zone includes LBODT
	 */
	lbodtFlex?: boolean;
	/**
	 * Array of zone new stops
	 */
	newZoneStops?: Array<StopViewCqrs>;
	/**
	 * Array of new zone zipcodes
	 */
	newZoneZipcodes?: Array<ZoneZipcode>;
	/**
	 * Notice text for LBODT to be shown on passengers app for reduced passengers with ticket
	 */
	reducedWithTicketNotice?: string;
	/**
	 * Notice text for LBODT to be shown on passengers app for reduced passengers without ticket
	 */
	reducedWithoutTicketNotice?: string;
	/**
	 * Array of zone stops that should be deleted
	 */
	removeZoneStops?: Array<string>;
	/**
	 * Array of zone zipcodes to be removed
	 */
	removeZoneZipcodes?: Array<string>;
	/**
	 * Notice text for LBODT to be shown on passengers app for time tickets
	 */
	timeTicketNotice?: string;
	/**
	 * Notice text to be shown on passengers app for toddlers definition
	 */
	toddlersDefinitionNotice?: string;
	/**
	 * Array of zone stops that are edited
	 */
	updateZoneStops?: Array<StopViewCqrs>;
	/**
	 * unique identification
	 */
	uuid: string;
};

/**
 * Object with zone zipcode options for a zone
 */
export type ZoneZipcode = {
	/**
	 * Label for zipcode
	 */
	label: string;
	zipCode: string;
};

export enum StopTypeEnum {
	VIRTUAL = 'VIRTUAL',
	PHYSICAL = 'PHYSICAL',
}

export enum StopCategoryEnum {
	TYPE1 = 'TYPE1',
	TYPE2 = 'TYPE2',
	ARCHIVED = 'ARCHIVED',
}

export enum StopBoardingEnum {
	IN_AND_OUT = 'IN_AND_OUT',
	IN = 'IN',
	OUT = 'OUT',
}

export type StopViewCqrs = {
	/**
	 * address of a stop
	 */
	address?: string;
	boarding?: StopBoardingEnum;
	category?: StopCategoryEnum;
	/**
	 * additional info about the stop
	 */
	description?: string;
	/**
	 * Name of the virtual stop
	 */
	label?: string;
	/**
	 * being long or lat, -180.0 to +180.0
	 */
	latitude?: string;
	/**
	 * link to the stop
	 */
	link?: string;
	/**
	 * being long or lat, -180.0 to +180.0
	 */
	longitude?: string;
	type?: StopTypeEnum;
	/**
	 * uuid of virtual stop
	 */
	uuid?: string;
};

/**
 * payload specific for command 'createVehicle'
 */
export type CommandPayloadUpdateVehicle = {
	/**
	 * maximum number of passengers
	 */
	capacity?: number;
	/**
	 * describes whether we could update vehicleType with future assignments
	 */
	force?: boolean;
	/**
	 * is this vehicle able to serve as LBODT
	 */
	lbodt?: boolean;
	/**
	 * is this vehicle able to serve as LBODTFLEX
	 */
	lbodtFlex?: boolean;
	licencePlate?: string;
	/**
	 * description or external ID of vehicle
	 */
	name?: string;
	neededDriverLicences?: DriverLicenses;
	/**
	 * is this vehicle able to serve as PRODT
	 */
	prodt?: boolean;
	specialNeeds?: SpecialNeedsEnum;
	/**
	 * unique identificator
	 */
	uuid: string;
	vehicleType?: VehicleTypeEnum;
};

/**
 * type of vehicle
 */
export enum VehicleTypeEnum {
	ECONOMY = 'ECONOMY',
	BUSINESS = 'BUSINESS',
	FIRST_CLASS = 'FIRST_CLASS',
	BUSINESS_VAN = 'BUSINESS_VAN',
}

export enum SpecialNeedsEnum {
	NONE = 'NONE',
	WHEELCHAIR_TYPE_1 = 'WHEELCHAIR_TYPE_1',
	WHEELCHAIR_TYPE_2 = 'WHEELCHAIR_TYPE_2',
}

/**
 * driver licence types
 */
export enum DriverLicenseEnum {
	A = 'A',
	B1 = 'B1',
	B = 'B',
	BE = 'BE',
	D1 = 'D1',
	D1E = 'D1E',
	D = 'D',
	DE = 'DE',
}

export type DriverLicenses = Array<DriverLicenseEnum>;

/**
 * payload specific for command 'updateTimeframe'. HTTP status code 422 is returned if another timeframe for given period exists on update
 * @deprecated
 */
export type CommandPayloadUpdateTimeframe = {
	/**
	 * extra costs for heavy luggage. Possible values >= 0. Also can be null
	 */
	bulkyLuggageCost?: number;
	cancellationRule?: CancellationRule;
	deploymentPriceIsPerBooking?: boolean;
	discountedTicketPresent?: TimeframePriceDefinition;
	/**
	 * minimal trip time. e.g. if this is 15 minutes, no lbodtflex trip will be offered shorter than 15 minutes
	 */
	minimalAcceptableTravelTimeMinutes?: number;
	/**
	 * minimum preorder time in minutes
	 */
	minimumPreorderTime?: number;
	noDiscount?: TimeframePriceDefinition;
	nonDiscountedTicketPresent?: TimeframePriceDefinition;
	/**
	 * is this timeframe active on public holidays
	 */
	onPublicHolidays?: boolean;
	/**
	 * is this timeframe active on special days
	 */
	onSpecialDays?: boolean;
	penaltyPointSystem?: PenaltyPointSystem;
	personalDiscountAvailable?: TimeframePriceDefinition;
	/**
	 * scheduling flexibility in minutes
	 */
	schedulingFlexibility?: number;
	/**
	 * multiplier for the normal drive time (according to navi)
	 */
	schedulingFlexibilityMultiplier?: number;
	serviceDays?: ServiceDays;
	/**
	 * The UUID of the timeframe
	 */
	uuid: string;
	validityEndDate?: string;
	validityEndTime?: string;
	validityStartDate?: string;
	validityStartTime?: string;
};

export enum DayOfWeek {
	MONDAY = 'MONDAY',
	TUESDAY = 'TUESDAY',
	WEDNESDAY = 'WEDNESDAY',
	THURSDAY = 'THURSDAY',
	FRIDAY = 'FRIDAY',
	SATURDAY = 'SATURDAY',
	SUNDAY = 'SUNDAY',
}

export type ServiceDays = Array<DayOfWeek>;

/**
 * Object with penalty point system options
 */
export type PenaltyPointSystem = {
	/**
	 * lbt weighting for distance from start point to end stop in km
	 */
	distanceFromEndPointToEndStopLbt?: number;
	/**
	 * odt weighting for distance from start point to end stop in km
	 */
	distanceFromEndPointToEndStopOdt?: number;
	/**
	 * lbt weighting for distance from start point to start stop in km
	 */
	distanceFromStartPointToStartStopLbt?: number;
	/**
	 * odt weighting for distance from start point to start stop in km
	 */
	distanceFromStartPointToStartStopOdt?: number;
	/**
	 * The offset is deducted from the penalty points of lbt. This can also be negative.
	 */
	lbtOffset?: number;
	/**
	 * lbt weighting for number of transfers
	 */
	numberOfTransfersLbt?: number;
	/**
	 * odt weighting for number of transfers
	 */
	numberOfTransfersOdt?: number;
	/**
	 * lbt weighting for trip duration in minutes with walk
	 */
	tripDurationWithWalkLbt?: number;
	/**
	 * odt weighting for trip duration in minutes with walk
	 */
	tripDurationWithWalkOdt?: number;
	/**
	 * lbt weighting for trip duration in minutes without walk
	 */
	tripDurationWithoutWalkLbt?: number;
	/**
	 * odt weighting for trip duration in minutes without walk
	 */
	tripDurationWithoutWalkOdt?: number;
	/**
	 * lbt weighting for waiting time until departure in minutes
	 */
	waitingTimeUntilDepartureLbt?: number;
	/**
	 * odt weighting for waiting time until departure in minutes
	 */
	waitingTimeUntilDepartureOdt?: number;
	/**
	 * lbt weighting for distance in km
	 */
	walkDistanceLbt?: number;
	/**
	 * odt weighting for distance in km
	 */
	walkDistanceOdt?: number;
	/**
	 * lbt weighting for walk duration in minutes
	 */
	walkDurationLbt?: number;
	/**
	 * odt weighting for walk duration in minutes
	 */
	walkDurationOdt?: number;
};

/**
 * Object with timeframe price definitions options for a timeframe
 */
export type TimeframePriceDefinition = {
	/**
	 * Amount in lowest currency unit (EUR = in cents)
	 */
	priceAirDistanceAmount?: number;
	/**
	 * Amount in lowest currency unit (EUR = in cents)
	 */
	priceDeploymentAmount?: number;
};

export type CancellationConditions = {
	/**
	 * maximum minutes before departure that this cancellation rule applies
	 */
	maxMinutesBeforeDeparture?: number;
	/**
	 * percentage of the ticket price that is refundable
	 */
	refundablePercent?: number;
};

/**
 * cancellation rule for the timeframe
 */
export type CancellationRule = {
	timeFees?: Array<CancellationConditions>;
};

/**
 * payload specific for command 'createVehicle'
 */
export type CommandPayloadUpdateShift = {
	/**
	 * allow automatic disposition
	 */
	automaticDisposition?: boolean;
	/**
	 * break length in minutes
	 */
	breakLength?: number;
	endLocation?: NamedLocation;
	endTime?: string;
	/**
	 * descriptive name of shift
	 */
	name?: string;
	/**
	 * is this shift active on school holidays
	 */
	onNonSchoolDays?: boolean;
	/**
	 * is this shift active on public holidays
	 */
	onPublicHolidays?: boolean;
	/**
	 * is this shift active on school days
	 */
	onSchoolDays?: boolean;
	/**
	 * is this shift active on special days
	 */
	onSpecialDays?: boolean;
	province?: ProvinceEnum;
	serviceDays?: ServiceDays;
	/**
	 * radius in km
	 */
	serviceRadius?: number;
	startLocation?: NamedLocation;
	startTime?: string;
	/**
	 * unique identificator
	 */
	uuid: string;
	validFrom?: string;
	validTo?: string;
};

export enum DisplayType {
	STOP = 'STOP',
	ADDRESS = 'ADDRESS',
	VIRTUAL_STOP = 'VIRTUAL_STOP',
}

export enum ProvinceEnum {
	BW = 'BW',
	BY = 'BY',
	BE = 'BE',
	BB = 'BB',
	HB = 'HB',
	HH = 'HH',
	HE = 'HE',
	MV = 'MV',
	NI = 'NI',
	NW = 'NW',
	RP = 'RP',
	SL = 'SL',
	SN = 'SN',
	ST = 'ST',
	SH = 'SH',
	TH = 'TH',
}

export type NamedLocation = {
	/**
	 * the address of the stop or location
	 */
	address?: string;
	/**
	 * being long or lat, -180.0 to +180.0
	 */
	lat: string;
	/**
	 * being long or lat, -180.0 to +180.0
	 */
	lng: string;
	/**
	 * if the location is a virtual stop, this is the stop name
	 */
	name: string;
	province?: ProvinceEnum;
	/**
	 * additional info about the stop
	 */
	stopDescription?: string;
	/**
	 * the stop link
	 */
	stopLink?: string;
	type: DisplayType;
	/**
	 * The zipcode of the from location
	 */
	zipcode?: string;
};

/**
 * payload specific for command 'createVehicle'
 */
export type CommandPayloadUpdateRecurringManualBookingLeg = {
	driverNotice?: string;
	/**
	 * descriptive name of shift
	 */
	name?: string;
	/**
	 * unique identifier
	 */
	uuid: string;
	validFrom?: string;
	validTo?: string;
};

/**
 * payload specific for command 'updateDriverNotice'
 */
export type CommandPayloadUpdateDriverNotice = {
	/**
	 * unique identificator for booking leg
	 */
	bookingLegId: string;
	/**
	 * the notice to set on the booking leg
	 */
	notice?: string;
};

export type CommandPayloadUpdateDriver = DriverBasics & {
	/**
	 * If while updating an blank or an empty string is send, we delete the business phone number of the driver.
	 */
	businessPhone?: string;
	driverLicences?: DriverLicenses;
	/**
	 * driver email
	 */
	email?: string;
	/**
	 * uuid of object
	 */
	firstName?: string;
	/**
	 * uuid of object
	 */
	lastName?: string;
	/**
	 * number of days, what is the period to the next driver licence check
	 */
	nextCheckDriverLicenceIn?: number;
	/**
	 * does a driver have a passenger transport licence
	 */
	passengerTransportLicencePresent?: boolean;
	/**
	 * Driver telefon number. If while updating an blank or an empty string is send, we delete the phone number of the driver.
	 */
	phone?: string;
	/**
	 * uuid of object
	 */
	uuid: string;
};

/**
 * contains common driver details to be extended by others
 */
export type DriverBasics = {
	firstName?: string;
	lastName?: string;
};

/**
 * update a distributor
 */
export type CommandPayloadUpdateDistributor = {
	agencyNames?: AgencyNames;
	/**
	 * application fee cut (in %) to be used for Stripe, it is number of hundredth part, e.g. 1 = 0.01, 10 = 0.10, 100 = 1.00
	 */
	applicationFeeCut?: number;
	/**
	 * name of distributor company
	 */
	distributorName?: string;
	distributorType?: DistributorType;
	/**
	 * connected account ID used to integrate payments with Stripe
	 */
	stripeConnectedAccountId?: string;
	/**
	 * uuid of object
	 */
	uuid: string;
};

export enum DistributorType {
	ON_DEMAND = 'ON_DEMAND',
	D_TICKET = 'D_TICKET',
	TICKET_SHOP = 'TICKET_SHOP',
	ON_DEMAND_D_TICKET = 'ON_DEMAND_D_TICKET',
}

/**
 * agency names as string array
 */
export type AgencyNames = Array<string>;

/**
 * payload specific for command 'updateCalendarEvent'
 */
export type CommandPayloadUpdateCalendarEvent = {
	eventId: string;
} & CalendarEvent;

export enum DayType {
	PUBLIC_HOLIDAY = 'PUBLIC_HOLIDAY',
	SCHOOL_HOLIDAY = 'SCHOOL_HOLIDAY',
	SPECIAL_DAY = 'SPECIAL_DAY',
}

export type CalendarEvent = {
	dayType?: DayType;
	from: string;
	note?: string;
	provinces: Array<ProvinceEnum>;
	to: string;
};

/**
 * payload specific for command 'updateBookingLegNotice'
 */
export type CommandPayloadUpdateBookingLegNotice = {
	/**
	 * unique identificator for booking leg
	 */
	bookingLegId: string;
	/**
	 * the notice to set on the booking leg
	 */
	notice?: string;
};

/**
 * payload specific for command 'updateAssignment'
 */
export type CommandPayloadUpdateAssignment = {
	/**
	 * unique identificator for that driver
	 */
	driverId?: string;
	/**
	 * unique identificator for that assignment
	 */
	uuid: string;
	/**
	 * unique identificator for that vehicle
	 */
	vehicleId?: string;
};

/**
 * payload specific for command 'triggerBookingPaymentManually'
 */
export type CommandPayloadTriggerBookingPaymentManually = {
	/**
	 * unique identifiactor for booking leg
	 */
	bookingLegId: string;
};

/**
 * payload specific for command 'startDrive'
 */
export type CommandPayloadStartDrive = {
	/**
	 * The id of the scheduled leg to start the drive of
	 */
	scheduledLegId: string;
};

/**
 * Set's the default payment method in the stripe api of the passenger. If a paymentMethodId is given, this will be used. Otherwise the setupIntentId is used if the setup was made with SOFORT.
 */
export type CommandPayloadSetDefaultPaymentMethod = {
	/**
	 * The id of the stripe's payment method
	 */
	paymentMethodId?: string;
	/**
	 * The id of the stripe's setup intent
	 */
	setupIntentId?: string;
};

/**
 * payload specific for command 'setBookingTripsToScheduleAutomatically', it works only for booked trips, which were not created manually
 */
export type CommandPayloadSetBookingTripsToScheduleAutomatically = {
	date: string;
};

/**
 * payload specific for command 'setBookingTripToScheduleAutomatically', it works only for booked trips, which were not created manually
 */
export type CommandPayloadSetBookingTripToScheduleAutomatically = {
	/**
	 * unique identificator for booking leg
	 */
	bookingLegId: string;
};

/**
 * payload specific for command 'setBookingTripToManualDisposition'
 */
export type CommandPayloadSetBookingTripToManualDisposition = {
	/**
	 * unique identification for booking leg
	 */
	bookingLegId: string;
};

/**
 * payload specific for command 'setAlternateInvoiceAddress'
 */
export type CommandPayloadSetAlternateInvoiceAddress = {
	/**
	 * Ort
	 */
	city?: string;
	/**
	 * company name
	 */
	company?: string;
	/**
	 * first name
	 */
	firstName?: string;
	/**
	 * last name
	 */
	lastName?: string;
	/**
	 * name of the street
	 */
	street?: string;
	/**
	 * street number
	 */
	streetNumber?: string;
	/**
	 * PLZ
	 */
	zipcode?: string;
};

/**
 * saves Location for a driver
 */
export type CommandPayloadSaveLocation = NamedLocation;

/**
 * payload specific for command 'saveDriverFiles'
 */
export type CommandPayloadSaveDriverFiles = {
	/**
	 * list of file uuids to be stored on driver
	 */
	fileIds: Array<string>;
	fileType: FileType;
};

/**
 * driver licence type
 */
export enum FileType {
	DRIVER_LICENSE = 'DRIVER_LICENSE',
	PASSENGER_TRANSPORT_LICENSE = 'PASSENGER_TRANSPORT_LICENSE',
}

/**
 * payload specific for command 'manuallyAssignToBookingLeg'
 */
export type CommandPayloadManuallyAssignToBookingLeg = {
	/**
	 * unique identification for assignment
	 */
	assignmentId: string;
	/**
	 * unique identification for booking leg
	 */
	bookingLegId: string;
};

/**
 * payload specific for command 'endDriveManually'
 */
export type CommandPayloadEndDriveManually = {
	/**
	 * The id of the scheduled leg to end the drive of
	 */
	scheduledLegId: string;
};

/**
 * payload specific for command 'endDrive'
 */
export type CommandPayloadEndDrive = {
	/**
	 * The id of the scheduled leg to end the drive of
	 */
	scheduledLegId: string;
};

/**
 * Payload specific for command 'deleteZone'. Zone with connected zone zipcodes will be deleted
 */
export type CommandPayloadDeleteZone = {
	/**
	 * unique identification
	 */
	uuid: string;
};

/**
 * payload specific for command 'createVehicle'
 */
export type CommandPayloadDeleteVehicle = {
	/**
	 * unique identificator
	 */
	uuid: string;
};

/**
 * payload specific for command 'deleteTimeframe'. Timeframe with related price definitions will be deleted
 */
export type CommandPayloadDeleteTimeframe = {
	/**
	 * The UUID of the timeframe
	 */
	uuid: string;
};

/**
 * payload specific for command 'createShift'
 */
export type CommandPayloadDeleteShift = {
	/**
	 * unique identificator
	 */
	uuid: string;
};

/**
 * payload specific for command 'deleteRecurringManualBookingLeg'
 */
export type CommandPayloadDeleteRecurringManualBookingLeg = {
	/**
	 * unique identifier
	 */
	uuid: string;
};

/**
 * payload specific for command 'deleteDriver'
 */
export type CommandPayloadDeleteDriver = {
	/**
	 * uuid of object
	 */
	uuid: string;
};

/**
 * Deletes the default payment method in the stripe api of the passenger
 * It does a sanity check equal to the canDeleteDefaultPaymentMethod command
 *
 */
export type CommandPayloadDeleteDefaultPaymentMethod = {
	[key: string]: unknown;
};

/**
 * payload specific for command 'deleteCalendarEvent'
 */
export type CommandPayloadDeleteCalendarEvent = {
	/**
	 * unique identificator
	 */
	eventId: string;
};

/**
 * payload specific for command 'deleteAssignment'
 */
export type CommandPayloadDeleteAssignment = {
	/**
	 * unique identificator for that assignment
	 */
	uuid: string;
};

/**
 * payload specific for command 'createZone'
 */
export type CommandPayloadCreateZone = {
	/**
	 * The label of the zone
	 */
	label: string;
	/**
	 * Flag to set if zone includes LBODT
	 */
	lbodtFlex: boolean;
	/**
	 * Notice text for LBODT to be shown on passengers app for reduced passengers with ticket
	 */
	reducedWithTicketNotice?: string;
	/**
	 * Notice text for LBODT to be shown on passengers app for reduced passengers without ticket
	 */
	reducedWithoutTicketNotice?: string;
	/**
	 * Notice text for LBODT to be shown on passengers app for time tickets
	 */
	timeTicketNotice?: string;
	/**
	 * Notice text to be shown on passengers app for toddlers definition
	 */
	toddlersDefinitionNotice?: string;
	/**
	 * Array of zone stops
	 */
	zoneStops?: Array<StopViewCqrs>;
	/**
	 * Array of zone zipcodes
	 */
	zoneZipcodes: Array<ZoneZipcode>;
};

/**
 * payload specific for command 'createVehicle'
 */
export type CommandPayloadCreateVehicle = {
	/**
	 * maximum number of passengers
	 */
	capacity: number;
	/**
	 * is this vehicle able to serve as LBODT
	 */
	lbodt: boolean;
	/**
	 * is this vehicle able to serve as LBODTFLEX
	 */
	lbodtFlex: boolean;
	licencePlate: string;
	/**
	 * description or external ID of vehicle
	 */
	name: string;
	neededDriverLicences: DriverLicenses;
	/**
	 * is this vehicle able to serve as PRODT
	 */
	prodt: boolean;
	specialNeeds: SpecialNeedsEnum;
	vehicleType: VehicleTypeEnum;
};

/**
 * create new user push token if not exists - used in app DRIVER and PASSENGER
 */
export type CommandPayloadCreateUserPushToken = {
	appContext?: AppContext;
	/**
	 * Token string generated from app DRIVER or PASSENGER
	 */
	pushToken?: string;
};

/**
 * payload specific for command 'createTimeframe'. HTTP status code 422 is returned if already a timeframe for given period exists
 * @deprecated
 */
export type CommandPayloadCreateTimeframe = {
	/**
	 * extra costs for heavy luggage. Possible values >= 0. Also can be null
	 */
	bulkyLuggageCost?: number;
	cancellationRule?: CancellationRule;
	deploymentPriceIsPerBooking?: boolean;
	discountedTicketPresent: TimeframePriceDefinition;
	/**
	 * minimal trip time. e.g. if this is 15 minutes, no lbodtflex trip will be offered shorter than 15 minutes
	 */
	minimalAcceptableTravelTimeMinutes?: number;
	/**
	 * minimum preorder time in minutes
	 */
	minimumPreorderTime: number;
	noDiscount: TimeframePriceDefinition;
	nonDiscountedTicketPresent: TimeframePriceDefinition;
	/**
	 * is this timeframe active on public holidays
	 */
	onPublicHolidays: boolean;
	/**
	 * is this timeframe active on special days
	 */
	onSpecialDays: boolean;
	penaltyPointSystem?: PenaltyPointSystem;
	personalDiscountAvailable: TimeframePriceDefinition;
	/**
	 * scheduling flexibility in minutes
	 */
	schedulingFlexibility: number;
	/**
	 * multiplier for the normal drive time (according to navi)
	 */
	schedulingFlexibilityMultiplier?: number;
	serviceDays: ServiceDays;
	validityEndDate?: string;
	validityEndTime: string;
	validityStartDate?: string;
	validityStartTime: string;
	/**
	 * The UUID of the zone
	 */
	zoneId: string;
};

/**
 * payload specific for command 'createVehicle'
 */
export type CommandPayloadCreateShift = {
	/**
	 * allow automatic disposition
	 */
	automaticDisposition: boolean;
	/**
	 * break length in minutes
	 */
	breakLength: number;
	endLocation?: NamedLocation;
	endTime: string;
	/**
	 * descriptive name of shift
	 */
	name: string;
	/**
	 * is this shift active on school holidays
	 */
	onNonSchoolDays: boolean;
	/**
	 * is this shift active on public holidays
	 */
	onPublicHolidays: boolean;
	/**
	 * is this shift active on school days
	 */
	onSchoolDays: boolean;
	/**
	 * is this shift active on special days
	 */
	onSpecialDays: boolean;
	province: ProvinceEnum;
	serviceDays: ServiceDays;
	/**
	 * radius in km
	 */
	serviceRadius: number;
	startLocation: NamedLocation;
	startTime: string;
	validFrom: string;
	validTo: string;
};

/**
 * payload specific for command 'createRecurringManualBookingLeg'
 */
export type CommandPayloadCreateRecurringManualBookingLeg = {
	driverNotice?: string;
	endLocation?: NamedLocation;
	endTime: string;
	/**
	 * descriptive name of shift
	 */
	name: string;
	/**
	 * is this shift active on school holidays
	 */
	onNonSchoolDays: boolean;
	/**
	 * is this shift active on public holidays
	 */
	onPublicHolidays: boolean;
	/**
	 * is this shift active on school days
	 */
	onSchoolDays: boolean;
	/**
	 * is this shift active on special days
	 */
	onSpecialDays: boolean;
	province: ProvinceEnum;
	serviceDays: ServiceDays;
	serviceType?: ManualTripType;
	/**
	 * unique identifier of a shift
	 */
	shiftId?: string;
	startLocation: NamedLocation;
	startTime: string;
	validFrom: string;
	validTo: string;
};

export enum ManualTripType {
	EMPTY = 'EMPTY',
	SPECIAL_SCHOOL_TRAFFIC = 'SPECIAL_SCHOOL_TRAFFIC',
	BLOCKER = 'BLOCKER',
	UNCATEGORIZED = 'UNCATEGORIZED',
}

/**
 * payload specific for command 'createGtfsTripFlexibility'
 */
export type CommandPayloadCreateGtfsTripFlexibility = {
	/**
	 * After new gtfs upload the gtfs trip diff must be accepted. If set to true, the json payload will be saved to file. User must have CAN_UPLOAD_GTFS_FILE privilege for this operation.
	 */
	acceptGtfsDiff?: boolean;
	/**
	 * Array of gtfs trip flexibilities
	 */
	gtfsTripFlexibilities: Array<GtfsTripFlexibility>;
};

/**
 * Object with flexibility options for a gtfs trip
 */
export type GtfsTripFlexibility = {
	/**
	 * AgencyName in given gtfs diff view. Used as part of identifier creation for gtfs flexibility options
	 */
	agencyName?: string;
	/**
	 * minimum preorder time in minutes
	 */
	minimumPreorderTime?: number;
	/**
	 * RouteName in given gtfs diff view. Used as part of identifier creation for gtfs flexibility options
	 */
	routeName?: string;
	/**
	 * scheduling flexibility in minutes
	 */
	schedulingFlexibility?: number;
	/**
	 * TripName in given gtfs diff view. Used as part of identifier creation for gtfs flexibility options
	 */
	tripName?: string;
};

export type CommandPayloadCreateDriver = DriverBasics & {
	/**
	 * driver phone number
	 */
	businessPhone?: string;
	driverLicences: DriverLicenses;
	/**
	 * driver email
	 */
	email: string;
	firstName?: string;
	lastName?: string;
	/**
	 * number of days, which is the period to the next driver licence check
	 */
	nextCheckDriverLicenceIn: number;
	/**
	 * does a driver have a passenger transport licence
	 */
	passengerTransportLicencePresent: boolean;
	/**
	 * driver phone number
	 */
	phone?: string;
};

/**
 * create a distributor
 */
export type CommandPayloadCreateDistributor = {
	/**
	 * email of admin account, connected to this distributor
	 */
	adminEmail?: string;
	agencyNames: AgencyNames;
	/**
	 * application fee cut (in %) to be used for Stripe, it is number of hundredth part, e.g. 1 = 0.01, 10 = 0.10, 100 = 1.00
	 */
	applicationFeeCut?: number;
	/**
	 * name of distributor company
	 */
	distributorName: string;
	distributorType?: DistributorType;
	/**
	 * email of first distributor user
	 */
	email: string;
	/**
	 * first name of first distributor user
	 */
	firstName: string;
	/**
	 * last name of first distributor user
	 */
	lastName: string;
	/**
	 * connected account ID used to integrate payments with Stripe
	 */
	stripeConnectedAccountId?: string;
};

/**
 * payload specific for command 'createCalendarEvent'
 */
export type CommandPayloadCreateCalendarEvent = CalendarEvent;

/**
 * manually create an empty trip (bookingLeg)
 */
export type CommandPayloadCreateBookingLegManually = {
	/**
	 * commentary info to the driver
	 */
	driverNotice?: string;
	endTime: string;
	fromLocation: NamedLocation;
	serviceType: ManualTripType;
	startTime: string;
	title: string;
	toLocation: NamedLocation;
};

/**
 * payload specific for command 'createAssignment'
 */
export type CommandPayloadCreateAssignment = {
	date: string;
	/**
	 * unique identificator for that driver
	 */
	driverId?: string;
	/**
	 * unique identificator for that shift
	 */
	shiftId: string;
	/**
	 * unique identificator for that vehicle
	 */
	vehicleId?: string;
};

/**
 * payload specific for command 'checkVehicle'
 */
export type CommandPayloadCheckVehicle = {
	/**
	 * unique id of assignment, where vehicle-check was done
	 */
	assignmentId: string;
	/**
	 * defines, whether driver's documents check was successful
	 */
	documentsCheck: boolean;
	/**
	 * optional field to be used to describe reasons of not successful driver's documents check
	 */
	documentsCheckNotice?: string;
	/**
	 * defines, whether vehicle's inside check was successful
	 */
	insideCheck: boolean;
	/**
	 * optional field to be used to describe reasons of not successful vehicle's inside check
	 */
	insideCheckNotice?: string;
	/**
	 * defines, whether vehicle's outside check was successful
	 */
	outsideCheck: boolean;
	/**
	 * optional field to be used to describe reasons of not successful vehicle's outside check
	 */
	outsideCheckNotice?: string;
};

/**
 * payload specific for command 'checkInPassenger'
 */
export type CommandPayloadCheckInPassenger = {
	/**
	 * The id of a booking
	 */
	bookingId: string;
	/**
	 * driver's cancellation reason description
	 */
	cancellationDescription?: string;
	/**
	 * reason of cancelling the passenger booking
	 */
	cancellationReason?: string;
	/**
	 * The id of the scheduled leg that the passenger entered on
	 */
	scheduledLegId: string;
};

/**
 * payload specific for command 'carryOutOutsideMopla'
 */
export type CommandPayloadCarryOutOutsideMopla = {
	/**
	 * unique identificator for booking leg
	 */
	bookingLegId: string;
};

/**
 * payload specific for command 'cancelSubscription'.
 */
export type CommandPayloadCancelSubscription = {
	cancellationReason: CancellationReasons;
	/**
	 * Custom cancellation reason typed in by user
	 */
	cancellationReasonDescription?: string;
	/**
	 * The UUID of the subscription
	 */
	uuid: string;
};

/**
 * Cancellation reasons as enum
 */
export enum CancellationReasonEnum {
	NOT_NEEDED_ANYMORE = 'NOT_NEEDED_ANYMORE',
	CANT_AFFORD = 'CANT_AFFORD',
	RECEIVING_THROUGH_EMPLOYER = 'RECEIVING_THROUGH_EMPLOYER',
	UNAWARE_OF_SUBSCRIPTION = 'UNAWARE_OF_SUBSCRIPTION',
	NOT_SATISFIED = 'NOT_SATISFIED',
	RECEIVING_CHEAPER = 'RECEIVING_CHEAPER',
	OTHER_REASON = 'OTHER_REASON',
	CANCEL_FOR_EMPLOYEE = 'CANCEL_FOR_EMPLOYEE',
	DELETE_SPENDIT_USER = 'DELETE_SPENDIT_USER',
	SUBSCRIPTION_PRICE_INCREASE = 'SUBSCRIPTION_PRICE_INCREASE',
}

export type CancellationReasons = Array<CancellationReasonEnum>;

/**
 * payload specific for command 'cancelBookingForBookingLeg', which needs Distributor access rights
 */
export type CommandPayloadCancelBookingForBookingLeg = {
	/**
	 * unique identificator for booking leg
	 */
	bookingLegId: string;
	/**
	 * when cancellationReason is OTHER, this field is required
	 */
	cancellationReasonDescription?: string;
	cancellationReasonDispatcher?: CancellationReasonDispatcherBookingEnum;
	/**
	 * whether to charge fees when cancelled or not
	 */
	withoutFees?: boolean;
};

/**
 * Cancellation reasons of dispatcher for bookings as enum
 */
export enum CancellationReasonDispatcherBookingEnum {
	NO_AVAILABLE_VEHICLES = 'NO_AVAILABLE_VEHICLES',
	TECHNICAL_VEHICLE_PROBLEM = 'TECHNICAL_VEHICLE_PROBLEM',
	PASSENGER_BLOCKED = 'PASSENGER_BLOCKED',
	PHONE_CANCELLATION = 'PHONE_CANCELLATION',
	DUPLICATED_BOOKING = 'DUPLICATED_BOOKING',
	OTHER = 'OTHER',
}

/**
 * a passenger wants to cancel a booking
 */
export type CommandPayloadCancelBooking = {
	/**
	 * The id of a booking
	 */
	bookingId: string;
	cancellationReason: CancellationReasonPassengerBookingEnum;
	/**
	 * description of cancellation reason
	 */
	cancellationReasonDescription?: string;
};

/**
 * Cancellation reasons of passenger for bookings as enum
 */
export enum CancellationReasonPassengerBookingEnum {
	RECEIVING_CHEAPER = 'RECEIVING_CHEAPER',
	NOT_NEEDED_ANYMORE = 'NOT_NEEDED_ANYMORE',
	OTHER_REASON = 'OTHER_REASON',
	DELAY = 'DELAY',
}

/**
 * checks if the default payment method of a passenger can be deleted
 */
export type CommandPayloadCanDeleteDefaultPaymentMethod = {
	[key: string]: unknown;
};

/**
 * payload specific for command 'bulkCreateAssignments'
 */
export type CommandPayloadBulkCreateAssignments = {
	/**
	 * unique identificator for that driver
	 */
	driverId?: string;
	from: string;
	serviceDays: ServiceDays;
	/**
	 * unique identificator for that shift
	 */
	shiftId: string;
	to: string;
	/**
	 * unique identificator for that vehicle
	 */
	vehicleId?: string;
};

/**
 * a passenger books a journey, i.e. one of the itineraries proposed by get /api/router/plan enriched with personal infos
 */
export type CommandPayloadBookJourney = {
	/**
	 * true if bulky luggage is present
	 */
	bulkyLuggage?: boolean;
	itinerary: ItineraryView;
	itineraryParams: ItineraryRequestedParams;
	passengerList: Array<PassengerDetailView>;
	/**
	 * the amount to be paid in the smallest currency unit (e.g. in cents for EUR, 250 is 2,50€)
	 */
	paymentAmount?: number;
	paymentForm?: PaymentFormEnum;
	/**
	 * number of toddler seats
	 */
	toddlerSeats?: number;
	voucherCode?: string;
};

export type PassengerDetailView = {
	discountState: DiscountStateEnum;
	email?: string;
	firstName?: string;
	isMainPassenger?: boolean;
	lastName?: string;
	phone?: string;
	specialNeeds?: SpecialNeedsEnum;
};

export enum DiscountStateEnum {
	NO_DISCOUNT = 'NO_DISCOUNT',
	DISCOUNTED_TICKET_PRESENT = 'DISCOUNTED_TICKET_PRESENT',
	NON_DISCOUNTED_TICKET_PRESENT = 'NON_DISCOUNTED_TICKET_PRESENT',
	PERSONAL_DISCOUNT_AVAILABLE = 'PERSONAL_DISCOUNT_AVAILABLE',
	SEVERELY_DISABLED = 'SEVERELY_DISABLED',
	COMPANION_OF_SEVERELY_DISABLED = 'COMPANION_OF_SEVERELY_DISABLED',
}

export type NamedLocationWithRequiredZipcodeAndProvince = {
	/**
	 * being long or lat, -180.0 to +180.0
	 */
	lat: string;
	/**
	 * being long or lat, -180.0 to +180.0
	 */
	lng: string;
	name: string;
	province: ProvinceEnum;
	type?: DisplayType;
	/**
	 * The zipcode of the from location
	 */
	zipcode: string;
};

export type ItineraryRequestedParams = {
	/**
	 * if true, interprete datetime as requested arrival, otherwise as requested departure
	 */
	arriveBy: boolean;
	datetime: string;
	fromPlace: NamedLocationWithRequiredZipcodeAndProvince;
	specialNeeds: SpecialNeedsEnum;
	toPlace: NamedLocationWithRequiredZipcodeAndProvince;
};

export enum VehicleType {
	ECONOMY = 'ECONOMY',
	BUSINESS = 'BUSINESS',
	FIRST_CLASS = 'FIRST_CLASS',
	BUSINESS_VAN = 'BUSINESS_VAN',
}

export type BookingLegTimeInfoViewStart = {
	/**
	 * Predicted start time based on real-time calculations.
	 */
	currentlyPredictedStartTime?: string;
	overwrittenStartTimeWindow?: TimeWindow;
	/**
	 * Start time of the booking leg. If start time not fixed already it´s the time that was planed for the start of the leg. If the time is fixed this is the time that was communicated to the passenger.
	 */
	startTime: string;
	/**
	 * Start time to consider for cancellation fee calculation.
	 */
	startTimeForCancellation?: string;
	startTimeWindow: TimeWindow;
};

/**
 * The original time window for the end, if it was overwritten.
 */
export type TimeWindow = {
	end: string;
	start: string;
};

export type BookingLegTimeInfoViewEnd = {
	/**
	 * Predicted end time based on real-time calculations.
	 */
	currentlyPredictedEndTime?: string;
	/**
	 * End time of the booking leg. If end time not fixed already it´s the time that was planed for the end of the leg. If the time is fixed this is the time that was communicated to the passenger.
	 */
	endTime: string;
	endTimeWindow: TimeWindow;
	overwrittenEndTimeWindow?: TimeWindow;
};

export type BookingLegTimeInfoView = {
	end?: BookingLegTimeInfoViewEnd;
	/**
	 * How much expected traffic delay is included in the timeframe.
	 */
	includedPlannedDelayInMinutes: number;
	start?: BookingLegTimeInfoViewStart;
	/**
	 * Indicates whether the start and end times are fixed.
	 */
	startAndEndTimeFixed: boolean;
};

export type PricingElementView = {
	amount?: number;
	currency?: CurrencyCodeEnum;
	/**
	 * Deployment price (per leg or total depending on config)
	 */
	deploymentPrice?: number;
	discount?: DiscountStateEnum;
	paymentHandlerCompanyName?: string;
	paymentHandlerCompanyType?: string;
	paymentInformationAvailable?: boolean;
	/**
	 * Price per passenger
	 */
	pricePerPassenger?: number;
};

export enum CurrencyCodeEnum {
	EUR = 'EUR',
}

export enum PaymentStateEnum {
	TO_PAY = 'TO_PAY',
	INVOICE_SEND = 'INVOICE_SEND',
	PAID = 'PAID',
	FAILED = 'FAILED',
}

export type SepaPaymentInfo = PaymentMethodInfo & {
	type?: 'SepaPaymentInfo';
} & {
	bankCode?: string;
};

export type PaymentMethodInfo = {
	type?: string;
};

export type PayByBankPaymentInfo = PaymentMethodInfo & {
	type?: 'PayByBankPaymentInfo';
} & {
	bankName?: string;
};

export type CardPaymentInfo = PaymentMethodInfo & {
	type?: 'CardPaymentInfo';
} & {
	cardBrand?: string;
	fundingType?: string;
	walletType?: string;
};

export enum PaymentFormEnum {
	CASH = 'CASH',
	CARD = 'CARD',
	DIGITAL = 'DIGITAL',
	NOT_NEEDED = 'NOT_NEEDED',
}

export enum PriceType {
	MOPLA = 'MOPLA',
	FREE = 'FREE',
	TARIFF = 'TARIFF',
}

export enum LineItemKindViewEnum {
	DRIVE_COST_PRODT = 'DRIVE_COST_PRODT',
	PLENTY_OF_PASSENGERS_FEE = 'PLENTY_OF_PASSENGERS_FEE',
	DEPLOYMENT_COST_NO_DISCOUNT = 'DEPLOYMENT_COST_NO_DISCOUNT',
	DEPLOYMENT_COST_DISCOUNTED_TICKET_PRESENT = 'DEPLOYMENT_COST_DISCOUNTED_TICKET_PRESENT',
	DEPLOYMENT_COST_NON_DISCOUNTED_TICKET_PRESENT = 'DEPLOYMENT_COST_NON_DISCOUNTED_TICKET_PRESENT',
	DEPLOYMENT_COST_PERSONAL_DISCOUNT_AVAILABLE = 'DEPLOYMENT_COST_PERSONAL_DISCOUNT_AVAILABLE',
	DEPLOYMENT_COST_SEVERELY_DISABLED = 'DEPLOYMENT_COST_SEVERELY_DISABLED',
	DEPLOYMENT_COST_COMPANION_OF_SEVERELY_DISABLED = 'DEPLOYMENT_COST_COMPANION_OF_SEVERELY_DISABLED',
	DEPLOYMENT_COST_RIDE_NO_DISCOUNT = 'DEPLOYMENT_COST_RIDE_NO_DISCOUNT',
	DEPLOYMENT_COST_RIDE_DISCOUNTED_TICKET_PRESENT = 'DEPLOYMENT_COST_RIDE_DISCOUNTED_TICKET_PRESENT',
	DEPLOYMENT_COST_RIDE_NON_DISCOUNTED_TICKET_PRESENT = 'DEPLOYMENT_COST_RIDE_NON_DISCOUNTED_TICKET_PRESENT',
	DEPLOYMENT_COST_RIDE_PERSONAL_DISCOUNT_AVAILABLE = 'DEPLOYMENT_COST_RIDE_PERSONAL_DISCOUNT_AVAILABLE',
	DEPLOYMENT_COST_RIDE_SEVERELY_DISABLED = 'DEPLOYMENT_COST_RIDE_SEVERELY_DISABLED',
	DEPLOYMENT_COST_RIDE_COMPANION_OF_SEVERELY_DISABLED = 'DEPLOYMENT_COST_RIDE_COMPANION_OF_SEVERELY_DISABLED',
	DEPLOYMENT_COST_PASSENGER_NO_DISCOUNT = 'DEPLOYMENT_COST_PASSENGER_NO_DISCOUNT',
	DEPLOYMENT_COST_PASSENGER_DISCOUNTED_TICKET_PRESENT = 'DEPLOYMENT_COST_PASSENGER_DISCOUNTED_TICKET_PRESENT',
	DEPLOYMENT_COST_PASSENGER_NON_DISCOUNTED_TICKET_PRESENT = 'DEPLOYMENT_COST_PASSENGER_NON_DISCOUNTED_TICKET_PRESENT',
	DEPLOYMENT_COST_PASSENGER_PERSONAL_DISCOUNT_AVAILABLE = 'DEPLOYMENT_COST_PASSENGER_PERSONAL_DISCOUNT_AVAILABLE',
	DEPLOYMENT_COST_PASSENGER_SEVERELY_DISABLED = 'DEPLOYMENT_COST_PASSENGER_SEVERELY_DISABLED',
	DEPLOYMENT_COST_PASSENGER_COMPANION_OF_SEVERELY_DISABLED = 'DEPLOYMENT_COST_PASSENGER_COMPANION_OF_SEVERELY_DISABLED',
	SEAT_UNKNOWN = 'SEAT_UNKNOWN',
	PASSENGER_NO_DISCOUNT = 'PASSENGER_NO_DISCOUNT',
	PASSENGER_DISCOUNTED_TICKET_PRESENT = 'PASSENGER_DISCOUNTED_TICKET_PRESENT',
	PASSENGER_NON_DISCOUNTED_TICKET_PRESENT = 'PASSENGER_NON_DISCOUNTED_TICKET_PRESENT',
	PASSENGER_PERSONAL_DISCOUNT_AVAILABLE = 'PASSENGER_PERSONAL_DISCOUNT_AVAILABLE',
	PASSENGER_SEVERELY_DISABLED = 'PASSENGER_SEVERELY_DISABLED',
	PASSENGER_COMPANION_OF_SEVERELY_DISABLED = 'PASSENGER_COMPANION_OF_SEVERELY_DISABLED',
	BULKY_LUGGAGE = 'BULKY_LUGGAGE',
	TODDLER_SEAT = 'TODDLER_SEAT',
	WHEELCHAIR_TRUNK = 'WHEELCHAIR_TRUNK',
	WHEELCHAIR_TRANSPORT = 'WHEELCHAIR_TRANSPORT',
	DISCOUNT_EARLY_BOOKING = 'DISCOUNT_EARLY_BOOKING',
	DISCOUNT_VOUCHER = 'DISCOUNT_VOUCHER',
}

export type LineItemView = {
	costWithTaxCent?: number;
	count?: number;
	kind?: LineItemKindViewEnum;
};

export type CancellationCostView = {
	costInCent?: number;
	secondsBeforeRideStart?: number;
};

/**
 * Holds information about the pricing structure/calculation. Since this view is uses before and after the booking process this field is not mandatory.Until the booking is booked we dont know the final pricing. So this field is only displayed after booking completion. This contains the current pricing, if it differs from originalPriceInfo, else null
 */
export type PricingView = {
	agencyName?: string;
	cancellationRules?: Array<CancellationCostView>;
	lineItems?: Array<LineItemView>;
	paymentHandlerCompanyName?: string;
	priceType?: PriceType;
	taxRate?: number;
	/**
	 * null if we have no pricing information
	 */
	totalCostBeforeReductionsCents?: number;
	/**
	 * null if we have no pricing information
	 */
	totalCostCents?: number;
	/**
	 * null if we have no pricing information
	 */
	totalTaxCents?: number;
	validUntil?: string;
};

/**
 * Holds information about the payment. Since this view is uses before and after the booking process this field is not mandatory.Until the booking is booked we dont know the finally payment information. So this field in only displayed after booking completion.
 */
export type BookingDetailPaymentInfoView = {
	currencyCode?: CurrencyCodeEnum;
	originalPriceInfo?: PricingView;
	overwritingPriceInfo?: PricingView;
	/**
	 * @deprecated
	 */
	overwrittenPaymentAmount?: number;
	/**
	 * @deprecated
	 */
	paymentAmount?: number;
	paymentForm: PaymentFormEnum;
	/**
	 * @deprecated
	 */
	paymentInformationAvailable?: boolean;
	paymentMethodInfo?:
		| PaymentMethodInfo
		| CardPaymentInfo
		| PayByBankPaymentInfo
		| SepaPaymentInfo;
	paymentState: PaymentStateEnum;
};

export type PassengerDetailsDto = {
	discountState?: DiscountStateEnum;
	email?: string;
	firstName?: string;
	/**
	 * This can be used to model legs sharing passengers.
	 */
	id?: string;
	isMainPassenger?: boolean;
	lastName?: string;
	phone?: string;
	specialNeeds?: SpecialNeedsEnum;
};

export enum TripTypeEnum {
	WALK = 'WALK',
	LBT = 'LBT',
	LBODT = 'LBODT',
	LBODTFLEX = 'LBODTFLEX',
	LBODTDS = 'LBODTDS',
	POOLODT = 'POOLODT',
	PRODT = 'PRODT',
	OTHERS = 'OTHERS',
	EMPTY = 'EMPTY',
	SPECIAL_SCHOOL_TRAFFIC = 'SPECIAL_SCHOOL_TRAFFIC',
	BLOCKER = 'BLOCKER',
	UNCATEGORIZED = 'UNCATEGORIZED',
	TRANSFER_WALK = 'TRANSFER_WALK',
}

export enum PassengerLegStatusEnum {
	BOOKED = 'BOOKED',
	SCHEDULED = 'SCHEDULED',
	DELAYED = 'DELAYED',
	CANCELLED = 'CANCELLED',
	DRIVER_ARRIVED = 'DRIVER_ARRIVED',
	CHECKED_IN = 'CHECKED_IN',
	ON_THE_WAY = 'ON_THE_WAY',
	COMPLETED = 'COMPLETED',
}

export type LegGeometryView = {
	length?: number;
	points?: string;
};

export type StopView = {
	arrival?: string;
	departure?: string;
	name?: string;
};

export type LegsPlaceView = {
	address?: string;
	arrival?: string;
	departure?: string;
	/**
	 * being long or lat, -180.0 to +180.0
	 */
	lat: string;
	/**
	 * being long or lat, -180.0 to +180.0
	 */
	lng: string;
	locationType?: DisplayType;
	/**
	 * if the location is a virtual stop, this is the stop name
	 */
	name: string;
	/**
	 * additional info about the stop
	 */
	stopDescription?: string;
	/**
	 * given, if stop is described as public stop in OTP
	 */
	stopId?: string;
	stopLink?: string;
};

export type FeedbackForBookingDto = {
	bookingLegId: string;
	comment: string;
	feedbackId: string;
	rating: number;
};

export type EarlyBookingDiscountDto = {
	discountRate: number;
	hoursBeforeTrip: number;
};

/**
 * A cancellation rule, i.e. a cost of cancellation that holds under certain conditions
 */
export type CancellationRuleView = {
	/**
	 * the amount to be paid in the smallest currency unit (e.g. in cents for EUR, 250 is 2,50€)
	 */
	cost: number;
	currency: CurrencyCodeEnum;
	discount: DiscountStateEnum;
	/**
	 * The cancellation rule applies only if the ride start is more than secondsBeforeRideStart in the future.
	 *
	 * If there's multiple cancellation rules with this property, the one with the larger secondsBeforeRideStart applies.
	 *
	 */
	secondsBeforeRideStart: number;
};

export type BulkyLuggageDto = {
	costPerUnit: number;
	maxCountPerRide: number;
	orderedCount?: number;
};

export type LegView = {
	agencyId?: string;
	agencyName?: string;
	bulkyLuggage?: BulkyLuggageDto;
	/**
	 * @deprecated
	 */
	cancellationFreeUntil?: string;
	cancellationRules?: Array<CancellationRuleView>;
	costOfCancellation?: number;
	delayed?: boolean;
	distance?: number;
	distributorContactEmail?: string;
	/**
	 * Only used in the plan endpoint to identify the distributor, to be able to request distributor infos for showing to the customer.
	 */
	distributorId?: string;
	duration?: number;
	earlyBookingDiscount?: EarlyBookingDiscountDto;
	/**
	 * @deprecated
	 */
	endDateTime: string;
	/**
	 * @deprecated
	 */
	endDateTimeFix: boolean;
	/**
	 * @deprecated
	 */
	endDateTimeWindowEnd?: string;
	/**
	 * @deprecated
	 */
	endDateTimeWindowStart?: string;
	feedback?: FeedbackForBookingDto;
	from: LegsPlaceView;
	headsign?: string;
	interlineWithPreviousLeg?: boolean;
	intermediateStops?: Array<StopView>;
	isBlacklisted?: boolean;
	lbodtflexLabel?: string;
	legGeometry?: LegGeometryView;
	legId: string;
	legStatus?: PassengerLegStatusEnum;
	maxDelayBeforeFreeCancellation?: number;
	mode: TripTypeEnum;
	modeOrigin?: string;
	/**
	 * @deprecated
	 */
	overwrittenEndTimeWindowEnd?: string;
	/**
	 * @deprecated
	 */
	overwrittenEndTimeWindowStart?: string;
	/**
	 * @deprecated
	 */
	overwrittenStartTimeWindowEnd?: string;
	/**
	 * @deprecated
	 */
	overwrittenStartTimeWindowStart?: string;
	passengerList?: Array<PassengerDetailsDto>;
	payment?: BookingDetailPaymentInfoView;
	paymentOptions?: Array<PaymentFormEnum>;
	pricings: Array<PricingElementView>;
	route?: string;
	routeId?: string;
	/**
	 * Zones of all distributors sharing the zone of this LBODTFLEX leg, zoneId included, in the order the capacity check tries them. Null outside shared zones.
	 */
	sharedZoneIds?: Array<string>;
	/**
	 * @deprecated
	 */
	startDateTime: string;
	/**
	 * @deprecated
	 */
	startDateTimeFix: boolean;
	/**
	 * @deprecated
	 */
	startDateTimeWindowEnd?: string;
	/**
	 * @deprecated
	 */
	startDateTimeWindowStart?: string;
	timeInfo?: BookingLegTimeInfoView;
	to: LegsPlaceView;
	tripId?: string;
	tripShortName?: string;
	vehicleType?: VehicleType;
	zoneId?: string;
};

export type ItineraryView = {
	airDistance?: number;
	/**
	 * Discount states whose price definition is bookable in the timeframe of every LBODTFLEX leg. Null for itineraries without an LBODTFLEX leg.
	 */
	bookableDiscountStates?: Array<DiscountStateEnum>;
	dticketEligible?: boolean;
	duration?: number;
	endDateTime: string;
	legs: Array<LegView>;
	luggageDefinition?: string;
	paymentOptions: Array<PaymentFormEnum>;
	reducedWithTicketDefinition?: string;
	reducedWithoutTicketDefinition?: string;
	signature?: string;
	startDateTime: string;
	stops?: number;
	stringForCrypto?: string;
	timeTicketDefinition?: string;
	toddlersDefinition?: string;
	transfers?: number;
	walkDistance?: number;
	walkTime?: number;
};

/**
 * payload specific for command 'adjustAssignment'
 */
export type CommandPayloadAdjustAssignment = {
	overwrittenEndLocation?: NamedLocation;
	overwrittenEndTime?: string;
	overwrittenStartLocation?: NamedLocation;
	overwrittenStartTime?: string;
	/**
	 * unique identificator for that assignment
	 */
	uuid: string;
};

/**
 * payload specific for command 'addPassengerDetails'
 */
export type CommandPayloadAddPassengerDetails = {
	/**
	 * Ort
	 */
	city?: string;
	dateOfBirth?: string;
	/**
	 * fist name
	 */
	firstName?: string;
	/**
	 * last name
	 */
	lastName?: string;
	phone?: string;
	/**
	 * name of the street
	 */
	street?: string;
	/**
	 * street number
	 */
	streetNumber?: string;
	/**
	 * PLZ
	 */
	zipcode?: string;
};

export type AddressDto = {
	city?: string;
	country?: string;
	street?: string;
	streetNumber?: string;
	zipCode?: string;
};

export type WhoAmIView = {
	address?: AddressDto;
	alternateInvoiceAddress?: AlternateInvoiceAddress;
	canAddTicketToWallet?: boolean;
	dateOfBirth?: string;
	disabilityStatusValidTo?: string;
	distributorId?: string;
	/**
	 * @deprecated
	 */
	distributorType?: string;
	distributorTypes?: Array<DistributorType>;
	email?: string;
	firstName?: string;
	hasDefaultStripePaymentMethod?: boolean;
	isBlacklisted?: boolean;
	isDisabled?: boolean;
	isDriverLicenceCheckNeeded?: boolean;
	isEligibleForJobticket?: boolean;
	isInMoplaArea?: boolean;
	isStripeCustomerConnected?: boolean;
	language?: string;
	lastName?: string;
	metaData?: {
		[key: string]: {
			[key: string]: unknown;
		};
	};
	name?: string;
	phone?: string;
	pleaseComplete?: boolean;
	privileges?: Array<PrivilegeEnum>;
	/**
	 * Set of roles assigned to the user.
	 */
	roles?: Array<UserRoleEnum>;
	userId?: string;
};

export enum UserRoleEnum {
	ADMIN = 'ADMIN',
	DRIVER = 'DRIVER',
	PASSENGER = 'PASSENGER',
	DISTRIBUTOR = 'DISTRIBUTOR',
	DISPATCHER = 'DISPATCHER',
	JOB_TICKET_ADMIN = 'JOB_TICKET_ADMIN',
}

export enum PrivilegeEnum {
	CAN_PAY_BOOKING_IN_VEHICLE = 'CAN_PAY_BOOKING_IN_VEHICLE',
	CAN_CREATE_NEW_PAYMENT_INTENT_SETUP = 'CAN_CREATE_NEW_PAYMENT_INTENT_SETUP',
	CAN_MAKE_BOOKING = 'CAN_MAKE_BOOKING',
	CAN_READ_BOOKINGS_OWN = 'CAN_READ_BOOKINGS_OWN',
	CAN_CANCEL_BOOKING_OWN = 'CAN_CANCEL_BOOKING_OWN',
	CAN_ADD_PASSENGER_DETAILS = 'CAN_ADD_PASSENGER_DETAILS',
	CAN_VERIFY_EMAIL_OWN = 'CAN_VERIFY_EMAIL_OWN',
	CAN_DELETE_ACCOUNT_OWN = 'CAN_DELETE_ACCOUNT_OWN',
	CAN_ADD_FAVOURITE_ADDRESS = 'CAN_ADD_FAVOURITE_ADDRESS',
	CAN_GET_ROUTE_PLAN = 'CAN_GET_ROUTE_PLAN',
	CAN_REDEEM_VOUCHER = 'CAN_REDEEM_VOUCHER',
	CAN_GET_ALL_VOUCHERS = 'CAN_GET_ALL_VOUCHERS',
	CAN_REMOVE_VOUCHERS = 'CAN_REMOVE_VOUCHERS',
	CAN_VALIDATE_PRODT_VOUCHER = 'CAN_VALIDATE_PRODT_VOUCHER',
	CAN_READ_TRIP_DRIVER_LOCATION = 'CAN_READ_TRIP_DRIVER_LOCATION',
	CAN_FETCH_TRUE_LAYER_ACCOUNTS = 'CAN_FETCH_TRUE_LAYER_ACCOUNTS',
	CAN_ADD_SEPA_FROM_TRUE_LAYER = 'CAN_ADD_SEPA_FROM_TRUE_LAYER',
	CAN_CHANGE_EMAIL_ADDRESS = 'CAN_CHANGE_EMAIL_ADDRESS',
	CAN_SAVE_LAST_LOCATION = 'CAN_SAVE_LAST_LOCATION',
	CAN_READ_DRIVER_APP = 'CAN_READ_DRIVER_APP',
	CAN_CHECK_IN_PASSENGER = 'CAN_CHECK_IN_PASSENGER',
	CAN_START_DRIVE_OWN = 'CAN_START_DRIVE_OWN',
	CAN_END_DRIVE_OWN = 'CAN_END_DRIVE_OWN',
	CAN_SAVE_LICENCE_FILES = 'CAN_SAVE_LICENCE_FILES',
	CAN_CHECK_VEHICLE_OWN = 'CAN_CHECK_VEHICLE_OWN',
	CAN_READ_SCHEDULE = 'CAN_READ_SCHEDULE',
	CAN_READ_SCHEDULE_DETAILS = 'CAN_READ_SCHEDULE_DETAILS',
	CAN_START_VEHICLE_CHECK = 'CAN_START_VEHICLE_CHECK',
	CAN_TRIGGER_EMERGENCY_CALLS = 'CAN_TRIGGER_EMERGENCY_CALLS',
	CAN_ADD_PUSH_TOKEN = 'CAN_ADD_PUSH_TOKEN',
	CAN_READ_SCHEDULED_TRIPS = 'CAN_READ_SCHEDULED_TRIPS',
	CAN_READ_SCHEDULED_TRIP_DETAILS = 'CAN_READ_SCHEDULED_TRIP_DETAILS',
	CAN_READ_BOOKED_TRIPS = 'CAN_READ_BOOKED_TRIPS',
	CAN_READ_BOOKED_TRIP_DETAILS = 'CAN_READ_BOOKED_TRIP_DETAILS',
	CAN_CANCEL_BOOKING_ALL = 'CAN_CANCEL_BOOKING_ALL',
	CAN_END_DRIVE_ALL = 'CAN_END_DRIVE_ALL',
	CAN_UPDATE_BOOKED_TRIPS = 'CAN_UPDATE_BOOKED_TRIPS',
	CAN_READ_HISTORY = 'CAN_READ_HISTORY',
	CAN_DOWNLOAD_BOOKED_TRIP_DETAILS = 'CAN_DOWNLOAD_BOOKED_TRIP_DETAILS',
	CAN_UPDATE_SCHEDULED_ASSIGNMENTS = 'CAN_UPDATE_SCHEDULED_ASSIGNMENTS',
	CAN_READ_MANUAL_BOOKED_TRIPS = 'CAN_READ_MANUAL_BOOKED_TRIPS',
	CAN_ASSIGN_BOOKED_TRIP_MANUALLY = 'CAN_ASSIGN_BOOKED_TRIP_MANUALLY',
	CAN_SET_BOOKED_TRIP_TO_AUTOMATICALLY_DISPOSAL = 'CAN_SET_BOOKED_TRIP_TO_AUTOMATICALLY_DISPOSAL',
	CAN_SET_BOOKED_TRIPS_TO_AUTOMATICALLY_DISPOSAL = 'CAN_SET_BOOKED_TRIPS_TO_AUTOMATICALLY_DISPOSAL',
	CAN_SET_BOOKED_TRIP_TO_CARRY_OUT_OUTSIDE = 'CAN_SET_BOOKED_TRIP_TO_CARRY_OUT_OUTSIDE',
	CAN_CREATE_BOOKED_TRIP = 'CAN_CREATE_BOOKED_TRIP',
	CAN_CANCEL_BOOKING_MANUAL = 'CAN_CANCEL_BOOKING_MANUAL',
	CAN_SET_BOOKED_TRIP_TO_MANUAL_DISPOSITION = 'CAN_SET_BOOKED_TRIP_TO_MANUAL_DISPOSITION',
	CAN_READ_SHIFTS = 'CAN_READ_SHIFTS',
	CAN_READ_SHIFT_DETAILS = 'CAN_READ_SHIFT_DETAILS',
	CAN_CREATE_SHIFT = 'CAN_CREATE_SHIFT',
	CAN_UPDATE_SHIFT = 'CAN_UPDATE_SHIFT',
	CAN_DELETE_SHIFT = 'CAN_DELETE_SHIFT',
	CAN_READ_ASSIGNMENTS = 'CAN_READ_ASSIGNMENTS',
	CAN_CREATE_ASSIGNMENT = 'CAN_CREATE_ASSIGNMENT',
	CAN_CREATE_ASSIGNMENTS = 'CAN_CREATE_ASSIGNMENTS',
	CAN_UPDATE_ASSIGNMENT = 'CAN_UPDATE_ASSIGNMENT',
	CAN_DELETE_ASSIGNMENT = 'CAN_DELETE_ASSIGNMENT',
	CAN_ADJUST_ASSIGNMENT = 'CAN_ADJUST_ASSIGNMENT',
	CAN_READ_VEHICLES = 'CAN_READ_VEHICLES',
	CAN_READ_VEHICLE_DETAILS = 'CAN_READ_VEHICLE_DETAILS',
	CAN_CREATE_VEHICLE = 'CAN_CREATE_VEHICLE',
	CAN_UPDATE_VEHICLE = 'CAN_UPDATE_VEHICLE',
	CAN_DELETE_VEHICLE = 'CAN_DELETE_VEHICLE',
	CAN_READ_DRIVERS = 'CAN_READ_DRIVERS',
	CAN_READ_DRIVER_DETAILS = 'CAN_READ_DRIVER_DETAILS',
	CAN_CREATE_DRIVER = 'CAN_CREATE_DRIVER',
	CAN_UPDATE_DRIVER = 'CAN_UPDATE_DRIVER',
	CAN_DELETE_DRIVER = 'CAN_DELETE_DRIVER',
	CAN_READ_DRIVER_RATINGS = 'CAN_READ_DRIVER_RATINGS',
	CAN_UPLOAD_GTFS_FILE = 'CAN_UPLOAD_GTFS_FILE',
	CAN_UPDATE_TRIP_FLEXIBILITY = 'CAN_UPDATE_TRIP_FLEXIBILITY',
	CAN_READ_LINES = 'CAN_READ_LINES',
	CAN_READ_TIMEFRAMES = 'CAN_READ_TIMEFRAMES',
	CAN_READ_TIMEFRAME_DETAILS = 'CAN_READ_TIMEFRAME_DETAILS',
	CAN_CREATE_TIMEFRAME = 'CAN_CREATE_TIMEFRAME',
	CAN_UPDATE_TIMEFRAME = 'CAN_UPDATE_TIMEFRAME',
	CAN_DELETE_TIMEFRAME = 'CAN_DELETE_TIMEFRAME',
	CAN_READ_ZONES = 'CAN_READ_ZONES',
	CAN_READ_ZONE_DETAILS = 'CAN_READ_ZONE_DETAILS',
	CAN_CREATE_ZONE = 'CAN_CREATE_ZONE',
	CAN_UPDATE_ZONE = 'CAN_UPDATE_ZONE',
	CAN_DELETE_ZONE = 'CAN_DELETE_ZONE',
	CAN_IMPORT_STOPS = 'CAN_IMPORT_STOPS',
	CAN_EXPORT_STOPS = 'CAN_EXPORT_STOPS',
	CAN_READ_CALENDAR_EVENTS = 'CAN_READ_CALENDAR_EVENTS',
	CAN_READ_CALENDAR_EVENTS_ON_DAY = 'CAN_READ_CALENDAR_EVENTS_ON_DAY',
	CAN_READ_CALENDAR_EVENT_DETAILS = 'CAN_READ_CALENDAR_EVENT_DETAILS',
	CAN_CREATE_CALENDAR_EVENT = 'CAN_CREATE_CALENDAR_EVENT',
	CAN_UPDATE_CALENDAR_EVENT = 'CAN_UPDATE_CALENDAR_EVENT',
	CAN_DELETE_CALENDAR_EVENT = 'CAN_DELETE_CALENDAR_EVENT',
	CAN_READ_DISPATCHERS = 'CAN_READ_DISPATCHERS',
	CAN_READ_DISPATCHER_DETAILS = 'CAN_READ_DISPATCHER_DETAILS',
	CAN_CREATE_DISPATCHER = 'CAN_CREATE_DISPATCHER',
	CAN_UPDATE_DISPATCHER = 'CAN_UPDATE_DISPATCHER',
	CAN_DELETE_DISPATCHER = 'CAN_DELETE_DISPATCHER',
	CAN_EXPORT_BOOKINGS = 'CAN_EXPORT_BOOKINGS',
	CAN_EXPORT_DELAYED_SHIFTS = 'CAN_EXPORT_DELAYED_SHIFTS',
	CAN_EXPORT_DIGITAL_LOGBOOK = 'CAN_EXPORT_DIGITAL_LOGBOOK',
	CAN_EXPORT_LBODTFLEX_PASSENGER_PRICES = 'CAN_EXPORT_LBODTFLEX_PASSENGER_PRICES',
	CAN_READ_DASHBOARD = 'CAN_READ_DASHBOARD',
	CAN_CREATE_RECURRING_MANUAL_BOOKING_LEG = 'CAN_CREATE_RECURRING_MANUAL_BOOKING_LEG',
	CAN_UPDATE_RECURRING_MANUAL_BOOKING_LEG = 'CAN_UPDATE_RECURRING_MANUAL_BOOKING_LEG',
	CAN_DELETE_RECURRING_MANUAL_BOOKING_LEG = 'CAN_DELETE_RECURRING_MANUAL_BOOKING_LEG',
	CAN_READ_RECURRING_MANUAL_BOOKING_LEG = 'CAN_READ_RECURRING_MANUAL_BOOKING_LEG',
	CAN_READ_SUBSCRIPTIONS_RELATED_TO_DISTRIBUTOR = 'CAN_READ_SUBSCRIPTIONS_RELATED_TO_DISTRIBUTOR',
	CAN_READ_TICKETS_RELATED_TO_DISTRIBUTOR = 'CAN_READ_TICKETS_RELATED_TO_DISTRIBUTOR',
	CAN_TOGGLE_SUBSCRIPTION_RELATED_TO_DISTRIBUTOR = 'CAN_TOGGLE_SUBSCRIPTION_RELATED_TO_DISTRIBUTOR',
	CAN_REGENERATE_TICKET = 'CAN_REGENERATE_TICKET',
	CAN_REVOKE_SUBSCRIPTION_CANCELLATION_RELATED_TO_DISTRIBUTOR = 'CAN_REVOKE_SUBSCRIPTION_CANCELLATION_RELATED_TO_DISTRIBUTOR',
	CAN_CANCEL_SUBSCRIPTION_PREORDER_RELATED_TO_DISTRIBUTOR = 'CAN_CANCEL_SUBSCRIPTION_PREORDER_RELATED_TO_DISTRIBUTOR',
	CAN_READ_USERS_RELATED_TO_DISTRIBUTOR = 'CAN_READ_USERS_RELATED_TO_DISTRIBUTOR',
	CAN_UPDATE_BLACKLIST_USERS_RELATED_TO_DISTRIBUTOR = 'CAN_UPDATE_BLACKLIST_USERS_RELATED_TO_DISTRIBUTOR',
	CAN_READ_DETAIL_INFO_USERS_RELATED_TO_DISTRIBUTOR = 'CAN_READ_DETAIL_INFO_USERS_RELATED_TO_DISTRIBUTOR',
	CAN_UPDATE_JOB_TICKET_BUSINESS_EMPLOYEE_ID = 'CAN_UPDATE_JOB_TICKET_BUSINESS_EMPLOYEE_ID',
	CAN_READ_USER_INFO_BY_EMAIL_REQUEST = 'CAN_READ_USER_INFO_BY_EMAIL_REQUEST',
	CAN_ARCHIVE_DRIVERS = 'CAN_ARCHIVE_DRIVERS',
	CAN_ARCHIVE_VEHICLES = 'CAN_ARCHIVE_VEHICLES',
	CAN_ARCHIVE_SHIFTS = 'CAN_ARCHIVE_SHIFTS',
	CAN_ARCHIVE_DISPATCHERS = 'CAN_ARCHIVE_DISPATCHERS',
	CAN_BOOK_FOR_SEVERELY_DISABLED = 'CAN_BOOK_FOR_SEVERELY_DISABLED',
	CAN_ADD_DISABILITY_STATUS = 'CAN_ADD_DISABILITY_STATUS',
	CAN_UPDATE_GLOBAL_DEFINITIONS = 'CAN_UPDATE_GLOBAL_DEFINITIONS',
	CAN_READ_OVERDUE_PAYMENT = 'CAN_READ_OVERDUE_PAYMENT',
	CAN_UPDATE_OVERDUE_PAYMENT = 'CAN_UPDATE_OVERDUE_PAYMENT',
	CAN_ADD_OVERDUE_PAYMENT_INFO = 'CAN_ADD_OVERDUE_PAYMENT_INFO',
	CAN_UPDATE_OVERDUE_PAYMENT_INFO = 'CAN_UPDATE_OVERDUE_PAYMENT_INFO',
	CAN_DELETE_OVERDUE_PAYMENT_INFO = 'CAN_DELETE_OVERDUE_PAYMENT_INFO',
	CAN_READ_DUNNING_EMAIL_CONFIGURATION = 'CAN_READ_DUNNING_EMAIL_CONFIGURATION',
	CAN_UPDATE_DUNNING_EMAIL_CONFIGURATION = 'CAN_UPDATE_DUNNING_EMAIL_CONFIGURATION',
	CAN_READ_DEPOT = 'CAN_READ_DEPOT',
	CAN_ADD_DEPOT = 'CAN_ADD_DEPOT',
	CAN_UPDATE_DEPOT = 'CAN_UPDATE_DEPOT',
	CAN_DELETE_DEPOT = 'CAN_DELETE_DEPOT',
	CAN_READ_DRIVER_LIVE_MAP = 'CAN_READ_DRIVER_LIVE_MAP',
	CAN_READ_PRODT_TIMEFRAME = 'CAN_READ_PRODT_TIMEFRAME',
	CAN_ADD_PRODT_TIMEFRAME = 'CAN_ADD_PRODT_TIMEFRAME',
	CAN_UPDATE_PRODT_TIMEFRAME = 'CAN_UPDATE_PRODT_TIMEFRAME',
	CAN_DELETE_PRODT_TIMEFRAME = 'CAN_DELETE_PRODT_TIMEFRAME',
	CAN_REMOVE_EMERGENCY_CALLS = 'CAN_REMOVE_EMERGENCY_CALLS',
	CAN_READ_EMERGENCY_CALLS = 'CAN_READ_EMERGENCY_CALLS',
	CAN_READ_BOOKINGS_RELATED_TO_DISTRIBUTOR = 'CAN_READ_BOOKINGS_RELATED_TO_DISTRIBUTOR',
	CAN_UPDATE_TICKET_RELATED_TO_DISTRIBUTOR = 'CAN_UPDATE_TICKET_RELATED_TO_DISTRIBUTOR',
	CAN_READ_DRIVER_FEEDBACKS_TABLE = 'CAN_READ_DRIVER_FEEDBACKS_TABLE',
	CAN_READ_DISTRIBUTORS = 'CAN_READ_DISTRIBUTORS',
	CAN_READ_DISTRIBUTOR_DETAILS = 'CAN_READ_DISTRIBUTOR_DETAILS',
	CAN_CREATE_DISTRIBUTOR = 'CAN_CREATE_DISTRIBUTOR',
	CAN_UPDATE_DISTRIBUTOR = 'CAN_UPDATE_DISTRIBUTOR',
	CAN_READ_EMAIL_DOMAIN = 'CAN_READ_EMAIL_DOMAIN',
	CAN_CREATE_EMAIL_DOMAIN = 'CAN_CREATE_EMAIL_DOMAIN',
	CAN_DELETE_EMAIL_DOMAIN = 'CAN_DELETE_EMAIL_DOMAIN',
	CAN_TRIGGER_NOTIFICATION_MANUALLY = 'CAN_TRIGGER_NOTIFICATION_MANUALLY',
	CAN_READ_VOUCHERS = 'CAN_READ_VOUCHERS',
	CAN_UPDATE_VOUCHERS = 'CAN_UPDATE_VOUCHERS',
	CAN_ADD_VOUCHERS = 'CAN_ADD_VOUCHERS',
	CAN_DELETE_VOUCHERS = 'CAN_DELETE_VOUCHERS',
	CAN_READ_JOB_TICKET_BUSINESSES = 'CAN_READ_JOB_TICKET_BUSINESSES',
	CAN_READ_JOB_TICKET_BUSINESS = 'CAN_READ_JOB_TICKET_BUSINESS',
	CAN_CREATE_JOB_TICKET_BUSINESS = 'CAN_CREATE_JOB_TICKET_BUSINESS',
	CAN_UPDATE_JOB_TICKET_BUSINESS = 'CAN_UPDATE_JOB_TICKET_BUSINESS',
	CAN_DELETE_JOB_TICKET_BUSINESS = 'CAN_DELETE_JOB_TICKET_BUSINESS',
	CAN_READ_JOB_TICKET_BUSINESS_EMPLOYEES = 'CAN_READ_JOB_TICKET_BUSINESS_EMPLOYEES',
	CAN_READ_JOB_TICKET_BUSINESS_EMPLOYEE = 'CAN_READ_JOB_TICKET_BUSINESS_EMPLOYEE',
	CAN_UPDATE_JOB_TICKET_BUSINESS_EMPLOYEE = 'CAN_UPDATE_JOB_TICKET_BUSINESS_EMPLOYEE',
	CAN_DELETE_JOB_TICKET_BUSINESS_EMPLOYEE = 'CAN_DELETE_JOB_TICKET_BUSINESS_EMPLOYEE',
	CAN_INVITE_JOB_TICKET_EMPLOYEE = 'CAN_INVITE_JOB_TICKET_EMPLOYEE',
	CAN_CANCEL_JOB_TICKET_SUBSCRIPTION = 'CAN_CANCEL_JOB_TICKET_SUBSCRIPTION',
	CAN_READ_GLOBAL_JOB_TICKET_BUSINESS_STATS = 'CAN_READ_GLOBAL_JOB_TICKET_BUSINESS_STATS',
	CAN_READ_JOB_TICKET_BUSINESS_STATS = 'CAN_READ_JOB_TICKET_BUSINESS_STATS',
	CAN_PAUSE_JOB_TICKET_SUBSCRIPTION = 'CAN_PAUSE_JOB_TICKET_SUBSCRIPTION',
	CAN_TRIGGER_TEST_MAILS = 'CAN_TRIGGER_TEST_MAILS',
	CAN_DO_ADMIN_STUFF = 'CAN_DO_ADMIN_STUFF',
	CAN_DO_DISTRIBUTOR_STUFF = 'CAN_DO_DISTRIBUTOR_STUFF',
	CAN_DO_DRIVER_STUFF = 'CAN_DO_DRIVER_STUFF',
	CAN_DO_SUBCONTRACTOR_STUFF = 'CAN_DO_SUBCONTRACTOR_STUFF',
	CAN_DO_PASSENGER_STUFF = 'CAN_DO_PASSENGER_STUFF',
}

export enum CountryEnum {
	USA = 'USA',
	AFGHANISTAN = 'AFGHANISTAN',
	ALBANIA = 'ALBANIA',
	ALGERIA = 'ALGERIA',
	ANDORRA = 'ANDORRA',
	ANGOLA = 'ANGOLA',
	ANTIGUA_DEPS = 'ANTIGUA_DEPS',
	ARGENTINA = 'ARGENTINA',
	ARMENIA = 'ARMENIA',
	AUSTRALIA = 'AUSTRALIA',
	AUSTRIA = 'AUSTRIA',
	AZERBAIJAN = 'AZERBAIJAN',
	BAHAMAS = 'BAHAMAS',
	BAHRAIN = 'BAHRAIN',
	BANGLADESH = 'BANGLADESH',
	BARBADOS = 'BARBADOS',
	BELARUS = 'BELARUS',
	BELGIUM = 'BELGIUM',
	BELIZE = 'BELIZE',
	BENIN = 'BENIN',
	BHUTAN = 'BHUTAN',
	BOLIVIA = 'BOLIVIA',
	BOSNIA_HERZEGOVINA = 'BOSNIA_HERZEGOVINA',
	BOTSWANA = 'BOTSWANA',
	BRAZIL = 'BRAZIL',
	BRUNEI = 'BRUNEI',
	BULGARIA = 'BULGARIA',
	BURKINA = 'BURKINA',
	BURMA = 'BURMA',
	BURUNDI = 'BURUNDI',
	CAMBODIA = 'CAMBODIA',
	CAMEROON = 'CAMEROON',
	CANADA = 'CANADA',
	CAPE_VERDE = 'CAPE_VERDE',
	CENTRAL_AFRICAN_REP = 'CENTRAL_AFRICAN_REP',
	CHAD = 'CHAD',
	CHILE = 'CHILE',
	CHINA = 'CHINA',
	REPUBLIC_OF_CHINA = 'REPUBLIC_OF_CHINA',
	COLOMBIA = 'COLOMBIA',
	COMOROS = 'COMOROS',
	DEMOCRATIC_REPUBLIC_OF_THE_CONGO = 'DEMOCRATIC_REPUBLIC_OF_THE_CONGO',
	REPUBLIC_OF_THE_CONGO = 'REPUBLIC_OF_THE_CONGO',
	COSTA_RICA = 'COSTA_RICA',
	CROATIA = 'CROATIA',
	CUBA = 'CUBA',
	CYPRUS = 'CYPRUS',
	CZECH_REPUBLIC = 'CZECH_REPUBLIC',
	DANZIG = 'DANZIG',
	DENMARK = 'DENMARK',
	DJIBOUTI = 'DJIBOUTI',
	DOMINICA = 'DOMINICA',
	DOMINICAN_REPUBLIC = 'DOMINICAN_REPUBLIC',
	EAST_TIMOR = 'EAST_TIMOR',
	ECUADOR = 'ECUADOR',
	EGYPT = 'EGYPT',
	EL_SALVADOR = 'EL_SALVADOR',
	EQUATORIAL_GUINEA = 'EQUATORIAL_GUINEA',
	ERITREA = 'ERITREA',
	ESTONIA = 'ESTONIA',
	ETHIOPIA = 'ETHIOPIA',
	FIJI = 'FIJI',
	FINLAND = 'FINLAND',
	FRANCE = 'FRANCE',
	GABON = 'GABON',
	GAZA_STRIP = 'GAZA_STRIP',
	THE_GAMBIA = 'THE_GAMBIA',
	GEORGIA = 'GEORGIA',
	GERMANY = 'GERMANY',
	GHANA = 'GHANA',
	GREECE = 'GREECE',
	GRENADA = 'GRENADA',
	GUATEMALA = 'GUATEMALA',
	GUINEA = 'GUINEA',
	GUINEA_BISSAU = 'GUINEA_BISSAU',
	GUYANA = 'GUYANA',
	HAITI = 'HAITI',
	HOLY_ROMAN_EMPIRE = 'HOLY_ROMAN_EMPIRE',
	HONDURAS = 'HONDURAS',
	HUNGARY = 'HUNGARY',
	ICELAND = 'ICELAND',
	INDIA = 'INDIA',
	INDONESIA = 'INDONESIA',
	IRAN = 'IRAN',
	IRAQ = 'IRAQ',
	REPUBLIC_OF_IRELAND = 'REPUBLIC_OF_IRELAND',
	ISRAEL = 'ISRAEL',
	ITALY = 'ITALY',
	IVORY_COAST = 'IVORY_COAST',
	JAMAICA = 'JAMAICA',
	JAPAN = 'JAPAN',
	JONATHANLAND = 'JONATHANLAND',
	JORDAN = 'JORDAN',
	KAZAKHSTAN = 'KAZAKHSTAN',
	KENYA = 'KENYA',
	KIRIBATI = 'KIRIBATI',
	NORTH_KOREA = 'NORTH_KOREA',
	SOUTH_KOREA = 'SOUTH_KOREA',
	KOSOVO = 'KOSOVO',
	KUWAIT = 'KUWAIT',
	KYRGYZSTAN = 'KYRGYZSTAN',
	LAOS = 'LAOS',
	LATVIA = 'LATVIA',
	LEBANON = 'LEBANON',
	LESOTHO = 'LESOTHO',
	LIBERIA = 'LIBERIA',
	LIBYA = 'LIBYA',
	LIECHTENSTEIN = 'LIECHTENSTEIN',
	LITHUANIA = 'LITHUANIA',
	LUXEMBOURG = 'LUXEMBOURG',
	MACEDONIA = 'MACEDONIA',
	MADAGASCAR = 'MADAGASCAR',
	MALAWI = 'MALAWI',
	MALAYSIA = 'MALAYSIA',
	MALDIVES = 'MALDIVES',
	MALI = 'MALI',
	MALTA = 'MALTA',
	MARSHALL_ISLANDS = 'MARSHALL_ISLANDS',
	MAURITANIA = 'MAURITANIA',
	MAURITIUS = 'MAURITIUS',
	MEXICO = 'MEXICO',
	MICRONESIA = 'MICRONESIA',
	MOLDOVA = 'MOLDOVA',
	MONACO = 'MONACO',
	MONGOLIA = 'MONGOLIA',
	MONTENEGRO = 'MONTENEGRO',
	MOROCCO = 'MOROCCO',
	MOUNT_ATHOS = 'MOUNT_ATHOS',
	MOZAMBIQUE = 'MOZAMBIQUE',
	NAMIBIA = 'NAMIBIA',
	NAURU = 'NAURU',
	NEPAL = 'NEPAL',
	NEWFOUNDLAND = 'NEWFOUNDLAND',
	NETHERLANDS = 'NETHERLANDS',
	NEW_ZEALAND = 'NEW_ZEALAND',
	NICARAGUA = 'NICARAGUA',
	NIGER = 'NIGER',
	NIGERIA = 'NIGERIA',
	NORWAY = 'NORWAY',
	OMAN = 'OMAN',
	OTTOMAN_EMPIRE = 'OTTOMAN_EMPIRE',
	PAKISTAN = 'PAKISTAN',
	PALAU = 'PALAU',
	PANAMA = 'PANAMA',
	PAPUA_NEW_GUINEA = 'PAPUA_NEW_GUINEA',
	PARAGUAY = 'PARAGUAY',
	PERU = 'PERU',
	PHILIPPINES = 'PHILIPPINES',
	POLAND = 'POLAND',
	PORTUGAL = 'PORTUGAL',
	PRUSSIA = 'PRUSSIA',
	QATAR = 'QATAR',
	ROMANIA = 'ROMANIA',
	ROME = 'ROME',
	RUSSIAN_FEDERATION = 'RUSSIAN_FEDERATION',
	RWANDA = 'RWANDA',
	GRENADINES = 'GRENADINES',
	SAMOA = 'SAMOA',
	SAN_MARINO = 'SAN_MARINO',
	SAO_TOME_PRINCIPE = 'SAO_TOME_PRINCIPE',
	SAUDI_ARABIA = 'SAUDI_ARABIA',
	SENEGAL = 'SENEGAL',
	SERBIA = 'SERBIA',
	SEYCHELLES = 'SEYCHELLES',
	SIERRA_LEONE = 'SIERRA_LEONE',
	SINGAPORE = 'SINGAPORE',
	SLOVAKIA = 'SLOVAKIA',
	SLOVENIA = 'SLOVENIA',
	SOLOMON_ISLANDS = 'SOLOMON_ISLANDS',
	SOMALIA = 'SOMALIA',
	SOUTH_AFRICA = 'SOUTH_AFRICA',
	SPAIN = 'SPAIN',
	SRI_LANKA = 'SRI_LANKA',
	SUDAN = 'SUDAN',
	SURINAME = 'SURINAME',
	SWAZILAND = 'SWAZILAND',
	SWEDEN = 'SWEDEN',
	SWITZERLAND = 'SWITZERLAND',
	SYRIA = 'SYRIA',
	TAJIKISTAN = 'TAJIKISTAN',
	TANZANIA = 'TANZANIA',
	THAILAND = 'THAILAND',
	TOGO = 'TOGO',
	TONGA = 'TONGA',
	TRINIDAD_TOBAGO = 'TRINIDAD_TOBAGO',
	TUNISIA = 'TUNISIA',
	TURKEY = 'TURKEY',
	TURKMENISTAN = 'TURKMENISTAN',
	TUVALU = 'TUVALU',
	UGANDA = 'UGANDA',
	UKRAINE = 'UKRAINE',
	UNITED_ARAB_EMIRATES = 'UNITED_ARAB_EMIRATES',
	UNITED_KINGDOM = 'UNITED_KINGDOM',
	URUGUAY = 'URUGUAY',
	UZBEKISTAN = 'UZBEKISTAN',
	VANUATU = 'VANUATU',
	VATICAN_CITY = 'VATICAN_CITY',
	VENEZUELA = 'VENEZUELA',
	VIETNAM = 'VIETNAM',
	YEMEN = 'YEMEN',
	ZAMBIA = 'ZAMBIA',
	ZIMBABWE = 'ZIMBABWE',
}

export type AlternateInvoiceAddress = {
	city?: string;
	company?: string;
	country?: CountryEnum;
	firstName?: string;
	lastName?: string;
	street?: string;
	streetNumber?: string;
	zipCode?: string;
};

export enum VoucherValueTypeEnum {
	EURO = 'EURO',
	PERCENT = 'PERCENT',
}

export type SortObject = {
	ascending?: boolean;
	direction?: string;
	ignoreCase?: boolean;
	nullHandling?: string;
	property?: string;
};

export type PageableObject = {
	offset?: number;
	pageNumber?: number;
	pageSize?: number;
	paged?: boolean;
	sort?: Array<SortObject>;
	unpaged?: boolean;
};

export enum PresenceStateEnum {
	PRESENT_VALID = 'PRESENT_VALID',
	PRESENT_INVALID = 'PRESENT_INVALID',
	ABSENT = 'ABSENT',
}

export type DriverMasterView = {
	canBeDeleted?: boolean;
	driverLicenceFilesState?: PresenceStateEnum;
	driverLicences?: string;
	firstName?: string;
	hasFailedCheck?: boolean;
	lastName?: string;
	passengerTransportLicencePresent?: boolean;
	uuid?: string;
};

export type ValidateVoucherDto = {
	bookingOptions: BookingOptionsDto;
	code: string;
	leg: LegView;
};

export type PassengerPricingDto = {
	discountState: DiscountStateEnum;
	specialNeeds: SpecialNeedsEnum;
};

export type BookingOptionsDto = {
	bulkyLuggageCount?: number;
	passengerList?: Array<PassengerPricingDto>;
	toddlerSeats?: number;
};

export type UserNewlyCreatedView = {
	createdUser?: string;
};

export type UsedVoucherDto = {
	bookingNumber: string;
	codeName: string;
	discountAmount: number;
	redeemedAt: string;
	value: number;
	valueType: VoucherValueTypeEnum;
};

export type UpdateLanguageDto = {
	language: string;
};

export type TriggerNotificationDto = {
	bookingId?: string;
	bookingNumber?: string;
	feeCharged?: boolean;
	notificationType: PushNotificationTypeEnum;
	scheduledBreakId?: string;
	scheduledLegId?: string;
	silent: boolean;
	subscriptionId?: string;
	subscriptionType?: SubscriptionTypeEnum;
	ticketId?: string;
	userUuid: string;
};

export enum SubscriptionTypeEnum {
	GERMANYTICKET = 'GERMANYTICKET',
	GERMANYTICKET_SPENDIT = 'GERMANYTICKET_SPENDIT',
	GERMANYTICKET_JOBTICKET_MOPLA = 'GERMANYTICKET_JOBTICKET_MOPLA',
}

export enum PushNotificationTypeEnum {
	TRIP_BOOKED = 'TRIP_BOOKED',
	TRIP_IMMUTABLE = 'TRIP_IMMUTABLE',
	PLAN_CHANGE = 'PLAN_CHANGE',
	PLAN_DELAY = 'PLAN_DELAY',
	TRIP_DELAYED = 'TRIP_DELAYED',
	TRIP_DELAY = 'TRIP_DELAY',
	POSSIBLE_DELAY = 'POSSIBLE_DELAY',
	DELAY_WITH_FREE_CANCELLATION = 'DELAY_WITH_FREE_CANCELLATION',
	UPCOMING_TRIP = 'UPCOMING_TRIP',
	CHECK_IN_PASSENGER = 'CHECK_IN_PASSENGER',
	CHECK_IN_PASSENGER_NO_SHOW = 'CHECK_IN_PASSENGER_NO_SHOW',
	CHECK_IN_PASSENGER_PAYMENT_SUCCEEDED = 'CHECK_IN_PASSENGER_PAYMENT_SUCCEEDED',
	CHECK_IN_PASSENGER_PAYMENT_FAILED = 'CHECK_IN_PASSENGER_PAYMENT_FAILED',
	DRIVER_ON_THE_WAY = 'DRIVER_ON_THE_WAY',
	TRIP_COMPLETED = 'TRIP_COMPLETED',
	TRIP_FEEDBACK = 'TRIP_FEEDBACK',
	BOOKING_CANCELED_BY_DISTRIBUTOR = 'BOOKING_CANCELED_BY_DISTRIBUTOR',
	BOOKING_CANCELED_FOR_DRIVER = 'BOOKING_CANCELED_FOR_DRIVER',
	BOOKING_CANCELED_BY_PASSENGER = 'BOOKING_CANCELED_BY_PASSENGER',
	DRIVER_REACHED_STOP = 'DRIVER_REACHED_STOP',
	LIVE_MAP_IS_AVAILABLE_PRODT = 'LIVE_MAP_IS_AVAILABLE_PRODT',
	LIVE_MAP_IS_AVAILABLE_NON_PRODT = 'LIVE_MAP_IS_AVAILABLE_NON_PRODT',
	D_TICKET_RECEIVED = 'D_TICKET_RECEIVED',
	D_TICKET_SUBSCRIPTION_PAUSE_STARTED = 'D_TICKET_SUBSCRIPTION_PAUSE_STARTED',
	D_TICKET_SUBSCRIPTION_STILL_PAUSED = 'D_TICKET_SUBSCRIPTION_STILL_PAUSED',
	D_TICKET_SUBSCRIPTION_WILL_RESUME = 'D_TICKET_SUBSCRIPTION_WILL_RESUME',
	D_TICKET_SUBSCRIPTION_PAYMENT_FAILED = 'D_TICKET_SUBSCRIPTION_PAYMENT_FAILED',
}

export type TicketView = {
	aztecCode?: string | null;
	firstName?: string;
	id?: string;
	lastName?: string;
	status?: TicketStateEnum;
	ticketId?: string;
	type?: string;
	validFrom?: string;
	validTo?: string;
};

export enum TicketStateEnum {
	VALID = 'VALID',
	INVALID = 'INVALID',
}

export type SubscriptionVoucherView = {
	longDescription?: string;
	shortDescription?: string;
	voucherCode?: string;
};

export type SubscriptionVoucherDto = {
	voucherCode: string;
};

/**
 * Passenger-facing subscription summary
 */
export type SubscriptionView = {
	canceledAt?: string;
	/**
	 * ISO-8601 datetime with offset: deadline by which the passenger must cancel to achieve the nextCancellationEffectiveDate.
	 */
	cancellationNoticeDeadline?: string;
	/**
	 * If true, the passenger cannot cancel the subscription cancellation.
	 */
	disallowCancelCancellation?: boolean;
	id?: string;
	/**
	 * ISO-8601 date (yyyy-MM-dd): subscription end date if the passenger cancels now, per Germany-ticket tariff (Berlin).
	 */
	nextCancellationEffectiveDate?: string;
	pauseEnd?: string;
	pauseStart?: string;
	status?: string;
	subscriptionStart?: string;
	type?: string;
};

export type SubscriptionIdYearMonthView = {
	month?: number;
	subscriptionId?: string;
	year?: number;
};

export type SubscriptionCreateDto = {
	recaptchaToken: string;
	startDate: string;
};

export type NamedLocationDto = {
	address?: string;
	lat: string;
	lng: string;
	name: string;
	province?: ProvinceEnum;
	stopDescription?: string;
	stopLink?: string;
	type?: DisplayType;
	zipcode?: string;
};

export type NamedLocationView = {
	address?: string;
	lat: string;
	lng: string;
	name: string;
	stopDescription?: string;
	stopLink?: string;
	type: DisplayType;
};

export type SetDefaultPaymentMethodDto = {
	paymentMethodId?: string;
	setupIntentId?: string;
};

export type SetAlternateInvoiceAddressDto = {
	city: string;
	company?: string;
	firstName: string;
	lastName: string;
	street: string;
	streetNumber: string;
	zipcode: string;
};

export type SendInvoiceEmailDto = {
	month: number;
	subscriptionId: string;
	year: number;
};

export enum SearchStatusEnum {
	IN_PROGRESS = 'IN_PROGRESS',
	SUCCESS = 'SUCCESS',
	NOTHING_FOUND = 'NOTHING_FOUND',
	CANCELLED = 'CANCELLED',
	EXPIRED = 'EXPIRED',
	TTL_EXPIRED = 'TTL_EXPIRED',
}

export type Scoring = {
	fieldScore?: {
		[key: string]: {
			[key: string]: unknown;
		};
	};
	queryScore?: number;
};

export type SchedulerView = {
	id?: string;
	schedulerState?: SchedulerStateEnum;
};

export enum SchedulerStateEnum {
	IN_PROGRESS = 'IN_PROGRESS',
	COMPLETED = 'COMPLETED',
	FAILED = 'FAILED',
}

export type ScheduledVehicleCheckView = {
	assignmentId?: string;
	checkDone?: boolean;
	end?: string;
	licencePlate?: string;
	start?: string;
};

export type ScheduledLegView = {
	consideredDelayed: boolean;
	distance?: number;
	end: string;
	enteringBookingLegs: Array<string>;
	enteringBookings?: Array<string>;
	estimatedEnd: string;
	estimatedStart: string;
	exitingBookingLegs: Array<string>;
	exitingBookings?: Array<string>;
	from?: NamedLocationView;
	immutableSince?: string;
	includedWaitingTime?: number;
	note?: string;
	passengers?: number;
	realStartTime?: string;
	scheduledLegId?: string;
	start: string;
	state?: ScheduledLegStateEnum;
	to?: NamedLocationView;
};

export enum ScheduledLegStateEnum {
	NEW = 'NEW',
	EXECUTING = 'EXECUTING',
	DONE = 'DONE',
}

export type ScheduledBreakView = {
	consideredDelayed: boolean;
	end?: string;
	estimatedEnd: string;
	estimatedStart: string;
	immutableSince?: string;
	location?: NamedLocationView;
	start?: string;
};

export type SaveDriverLocationDto = {
	/**
	 * Accuracy of the location in meter. Should not be negative
	 */
	accuracy: string;
	/**
	 * The capture time of the location
	 */
	captureTime: string;
	/**
	 * Latitude of the location
	 */
	latitude: string;
	/**
	 * Longitude of the location
	 */
	longitude: string;
};

export type RunSchedulerDto = {
	distributorId: string;
	from: string;
	planFreshBookings?: boolean;
	to: string;
};

export type RouterPlanResponseView = {
	itineraries?: Array<ItineraryView>;
	privateTripAvailable?: boolean;
	privateTripDetails?: PrivateTripDetailsView;
	privateTrips?: Array<PrivateTripDetailsView>;
	requestedParams?: RequestedParams;
};

export type RequestedParams = {
	arriveBy: boolean;
	datetime: string;
	fromPlace: NamedLocationDto;
	specialNeeds: SpecialNeedsEnum;
	toPlace?: NamedLocationDto;
};

export type PrivateTripDetailsView = {
	durationInSeconds?: number;
	maxPassengerCount?: number;
	maxPrice?: number;
	minPrice?: number;
	vehicleType?: VehicleType;
};

export enum AppEnum {
	PASSENGER = 'PASSENGER',
	DRIVER = 'DRIVER',
	DISTRIBUTOR = 'DISTRIBUTOR',
	JOB_TICKET_ADMIN = 'JOB_TICKET_ADMIN',
	JOB_TICKET_EMPLOYEE = 'JOB_TICKET_EMPLOYEE',
}

export type RequestParamsView = {
	alternativesDirection?: AlternativesDirectionEnum;
	arriveBy?: boolean;
	datetime?: string;
	fromPlace?: NamedLocationDto;
	pax?: number;
	specialNeeds?: SpecialNeedsEnum;
	toPlace?: NamedLocationDto;
	vehicleType: VehicleType;
};

export enum AlternativesDirectionEnum {
	BEFORE = 'BEFORE',
	AFTER = 'AFTER',
}

export type PublicTransportDistributorInfoView = {
	conditionsOfCarriageLinkPublicTransport: string;
	publicTransportCompanyName: string;
};

export type ProdtVoucherView = {
	calculatedValueCents: number;
	id: string;
	value: number;
	valueType: VoucherValueTypeEnum;
};

export type ProdtDistributorInfoView = {
	conditionsOfCarriageLinkProdt: string;
	prodtCompanyName: string;
};

export type PrivateTripSearchView = {
	id: string;
	progress?: CapacityCheckProgressView;
	requestedParams: RequestParamsView;
	result?: CapacityCheckResultViewV2;
	status: SearchStatusEnum;
};

export type CapacityCheckResultViewV2 = {
	alternativeVehicleType?: boolean;
	itinerary: ItineraryView;
	reservedUntil?: string;
};

export type CapacityCheckProgressView = {
	maxTripDeviationMinutes?: number;
	numberOfRounds: number;
	roundIndex: number;
};

export type PrivateTripSearchRequestDto = {
	arriveBy: boolean;
	datetime: string;
	fromPlace: NamedLocationDto;
	pax: number;
	specialNeeds: SpecialNeedsEnum;
	/**
	 * ttl in seconds. After this many seconds, the search is automatically cancelled
	 */
	timeToLive?: number;
	toPlace: NamedLocationDto;
	vehicleType?: VehicleType;
};

export type PriceCalculationDto = {
	bookingOptions?: BookingOptionsDto;
	leg?: LegView;
	voucherCode?: string;
};

export type Position = {
	lat?: number;
	lng?: number;
};

export type PaymentMethodSetupStatusView = {
	status: PaymentMethodSetupStatusEnum;
};

export enum PaymentMethodSetupStatusEnum {
	NONE = 'NONE',
	PENDING = 'PENDING',
	FAILED = 'FAILED',
}

export type PassengerPriceInfoAggregateView = {
	currencyCode?: CurrencyCodeEnum;
	/**
	 * Price types of contained legs for display
	 */
	priceTypes: Array<PriceType>;
	totalChargedCancellationFeeCents?: number;
	/**
	 * sum of costs for all legs of PriceType.MOPLA
	 */
	totalCostCents?: number;
};

export type PassengerCanDeleteDefaultPaymentMethodView = {
	canDeleteDefaultPaymentMethod?: boolean;
};

export type PassengerCanBeDeletedView = {
	canBeDeleted?: boolean;
};

export type PassengerBookingView = {
	/**
	 * A code to mach this ride with the passenger, 4 letters, latin, uppercase
	 */
	bookingCode: string;
	bookingNumber: string;
	bookingStatus: BookingStateEnum;
	bulkyLuggage?: boolean;
	/**
	 * Until when the trip can still be cancelled by the passenger. Only set for school trips; null means no cancellation cutoff applies.
	 */
	cancellableUntil?: string;
	cancellationReason?: CancellationReasonDispatcherBookingEnum;
	deleted: boolean;
	id: string;
	itinerary: ItineraryView;
	originalPriceInfoAggregate: PassengerPriceInfoAggregateView;
	overwritingPriceInfoAggregate?: PassengerPriceInfoAggregateView;
	passengerList?: Array<PassengerDetailView>;
	passengers?: number;
	payment: BookingDetailPaymentInfoAggregateView;
	paymentState: PaymentStateEnum;
	specialNeeds: SpecialNeedsEnum;
	toddlerSeats?: number;
	updatedTime: string;
	usedVoucher?: UsedVoucherDto;
};

export type BookingDetailPaymentInfoAggregateView = {
	currencyCode?: CurrencyCodeEnum;
	overwrittenPaymentAmount?: number;
	paymentAmount?: number;
	paymentForm: PaymentFormEnum;
	paymentInformationAvailable?: boolean;
	paymentMethodInfo?:
		| PaymentMethodInfo
		| CardPaymentInfo
		| PayByBankPaymentInfo
		| SepaPaymentInfo;
	paymentState: PaymentStateEnum;
};

export enum BookingStateEnum {
	NEW = 'NEW',
	EXECUTING = 'EXECUTING',
	FINISHED = 'FINISHED',
	CANCELLED_BY_DISTRIBUTOR = 'CANCELLED_BY_DISTRIBUTOR',
	CANCELLED_BY_PASSENGER = 'CANCELLED_BY_PASSENGER',
	CANCELLED_BY_DRIVER = 'CANCELLED_BY_DRIVER',
}

export type Pageable = {
	page?: number;
	size?: number;
	sort?: Array<string>;
};

export type PagePassengerBookingView = {
	content?: Array<PassengerBookingView>;
	empty?: boolean;
	first?: boolean;
	last?: boolean;
	number?: number;
	numberOfElements?: number;
	pageable?: PageableObject;
	size?: number;
	sort?: Array<SortObject>;
	totalElements?: number;
	totalPages?: number;
};

export type PageFeedbackSummaryDto = {
	content?: Array<FeedbackSummaryDto>;
	empty?: boolean;
	first?: boolean;
	last?: boolean;
	number?: number;
	numberOfElements?: number;
	pageable?: PageableObject;
	size?: number;
	sort?: Array<SortObject>;
	totalElements?: number;
	totalPages?: number;
};

export type FeedbackSummaryDto = {
	bookingNumber?: string;
	comment?: string;
	createdTime?: string;
	driverName?: string;
	id?: string;
	rating?: number;
	userName?: string;
};

export type Offer = {
	fullPrice?: number;
	isJobticket?: boolean;
	price?: number;
	startDate?: string;
	subscriptionType?: SubscriptionTypeEnum;
	voucherCode?: string;
	voucherDeductionAmount?: number;
	voucherLongDescription?: string;
	voucherShortDescription?: string;
};

export type NewSetupIntentView = {
	pkKey?: string;
	stripeCustomerId?: string;
	stripeEphemeralKeySecret?: string;
	stripeSetupIntentClientSecret?: string;
};

export type MapView = {
	east?: number;
	north?: number;
	south?: number;
	west?: number;
};

export type LookupResponse = {
	access?: Array<Position>;
	additional?: {
		[key: string]: {
			[key: string]: unknown;
		};
	};
	address?: AddressHereApi;
	categories?: Array<Category>;
	distance?: number;
	id?: string;
	mapView?: {
		[key: string]: {
			[key: string]: unknown;
		};
	};
	position?: Position;
	references?: Array<{
		[key: string]: {
			[key: string]: unknown;
		};
	}>;
	resultType?: string;
	scoring?: Scoring;
	title?: string;
};

export type Category = {
	id?: string;
	name?: string;
	primary?: boolean;
};

export type AddressHereApi = {
	city?: string;
	countryCode?: string;
	countryName?: string;
	county?: string;
	countyCode?: string;
	district?: string;
	houseNumber?: string;
	label?: string;
	postalCode?: string;
	state?: string;
	stateCode?: string;
	street?: string;
};

export type Location = {
	county?: string;
	lat?: string;
	lng?: string;
	locationOfStop?: boolean;
	name?: string;
	type?: DisplayType;
	zipcode?: string;
};

export type LegRating = {
	bookingLegId: string;
	comment: string;
	rating: number;
};

export type LbodtflexCapacityCheckViewV2 = {
	id: string;
	progress?: CapacityCheckProgressView;
	requestedParams: CapacityCheckRequestParamsView;
	result?: CapacityCheckResultViewV2;
	status: SearchStatusEnum;
};

export type CapacityCheckRequestParamsView = {
	alternativesDirection?: AlternativesDirectionEnum;
	itinerary: ItineraryView;
	pax: number;
	specialNeeds: SpecialNeedsEnum;
};

export type LbodtflexCapacityCheckView = {
	id: string;
	progress?: CapacityCheckProgressView;
	requestedParams: CapacityCheckRequestParamsView;
	/**
	 * @deprecated
	 */
	reservedUntil?: string;
	result?: CapacityCheckResultView;
	status: SearchStatusEnum;
};

export type CapacityCheckResultView = {
	alternativeVehicleType?: boolean;
	itinerary: ItineraryView;
	reservedUntil: string;
};

export type LbodtflexCapacityCheckRequestDto = {
	itinerary: ItineraryView;
	pax: number;
	specialNeeds: SpecialNeedsEnum;
	/**
	 * ttl in seconds. After this many seconds, the capacity check is automatically cancelled
	 */
	timeToLive?: number;
};

export type LbodtFlexDistributorInfoView = {
	conditionsOfCarriageLinkPublicTransport: string;
	lbodtFlexLabel: string;
	publicTransportCompanyName: string;
};

export type Item = {
	access?: Array<Access>;
	address?: AddressHereApi;
	distance?: number;
	houseNumberType?: string;
	id?: string;
	mapView?: MapView;
	position?: Position;
	resultType?: string;
	title?: string;
};

export type Access = {
	lat?: number;
	lng?: number;
};

export type GoogleWalletView = {
	link?: string;
};

export type GiveFeedbackForBookingDto = {
	legRatings: Array<LegRating>;
};

export type GermanyTicketSubscriptionOfferingView = {
	fullPrice?: number;
	isJobticket?: boolean;
	offers?: Array<Offer>;
	price?: number;
	surchargePercentage?: number;
};

export type FileLinkView = {
	fileId?: string;
	name?: string;
};

export type FeatureFlagView2 = {
	validUntil: string;
	value: boolean;
};

export type ErrorResponseDto = {
	code?: string;
	error?: string;
	message?: string;
	path?: string;
	status?: number;
};

export enum EmergencyCallStateEnum {
	ACTIVATED = 'ACTIVATED',
	DEACTIVATED = 'DEACTIVATED',
	OFF = 'OFF',
}

export type EmailValidationDto = {
	isValid?: boolean;
};

export type EmailChangeDto = {
	email: string;
	origin?: AppEnum;
};

export type EmailChangeCodeDto = {
	code: string;
};

export type DriverScheduleView = {
	driverLegType?: DriverLegTypeEnum;
	/**
	 * Dynamic object based on the ref value (LEG, BREAK, or VEHICLE_CHECK)
	 */
	obj?: ScheduledLegView | ScheduledBreakView | ScheduledVehicleCheckView;
	ref?: DriverScheduleTripTypeEnum;
};

export enum DriverScheduleTripTypeEnum {
	LEG = 'LEG',
	BREAK = 'BREAK',
	VEHICLE_CHECK = 'VEHICLE_CHECK',
}

export enum DriverLegTypeEnum {
	LBODTLBODTFLEX = 'LBODTLBODTFLEX',
	MANUAL = 'MANUAL',
	PRODT = 'PRODT',
	EMPTY = 'EMPTY',
}

export type DriverMasterViewPage = {
	content?: Array<DriverMasterView>;
	empty?: boolean;
	first?: boolean;
	last?: boolean;
	number?: number;
	numberOfElements?: number;
	pageable?: PageableObject;
	size?: number;
	sort?: Array<SortObject>;
	totalElements?: number;
	totalPages?: number;
};

export type DriverMapView = {
	businessPhone?: string;
	currentLocation: NamedLocationView;
	driverName: string;
	hasPassengers: boolean;
	lastStopLocation: NamedLocationView;
	licencePlate: string;
	nextStopLocation: NamedLocationView;
	nextStopTime: string;
	pauseEndTime: string;
	state: string;
	updateTime: string;
};

export type DriverLocationPassengerMapDto = {
	currentLocation: NamedLocationView;
	estimatedArrivalTime: string;
	isDelayed: boolean;
	lastLocationUpdate: string;
	legId: string;
	licensePlate: string;
	serviceType: TripTypeEnum;
	stopsLeft: number;
};

export type DriverFileView = {
	fileType?: DriverFileTypeEnum;
	mimeType?: string;
	name?: string;
	uploadedBy?: string;
	uuid?: string;
};

export enum DriverFileTypeEnum {
	DRIVER_LICENSE = 'DRIVER_LICENSE',
	PASSENGER_TRANSPORT_LICENSE = 'PASSENGER_TRANSPORT_LICENSE',
}

export type DriverDetailView = {
	averageRating?: number;
	businessPhone?: string;
	canBeDeleted: boolean;
	checks: Array<DriverCheckView>;
	driverLicenceFiles: Array<DriverFileView>;
	driverLicences: Array<DriverLicenseEnum>;
	email: string;
	firstName: string;
	lastCheckDriverLicence: string;
	lastName: string;
	nextCheckDriverLicence: string;
	nextCheckDriverLicenceIn: number;
	passengerTransportLicencePresent: boolean;
	phone?: string;
	uuid: string;
};

export type DriverCheckView = {
	date: string;
	documentsCheck: boolean;
	documentsCheckNotice?: string;
	uuid: string;
};

export type DriverCarDetailsDto = {
	carLicensePlate: string;
	displayName: string;
};

export type DriverBookingLegDetailView = {
	/**
	 * A code to mach this ride with the passenger, 4 letters, latin, uppercase
	 */
	bookingCode: string;
	bookingId?: string;
	bookingLegId: string;
	bookingState?: BookingStateEnum;
	bulkyLuggage?: boolean;
	checkedInScheduledLegs?: Array<CheckedInScheduledLegs>;
	currencyCode?: CurrencyCodeEnum;
	passengerList?: Array<PassengerDetailView>;
	paymentAmount?: number;
	paymentForm?: PaymentFormEnum;
	paymentState?: PaymentStateEnum;
	specialNeeds?: SpecialNeedsEnum;
	toddlerSeats?: number;
};

export type CheckedInScheduledLegs = {
	isCheckedIn: boolean;
	scheduledLegId: string;
};

export type DigitalBonusView = {
	amount?: number;
	code?: string;
	isEligible?: boolean;
	validUntil?: string;
};

export type CreateSepaPaymentRequestDto = {
	address?: {
		[key: string]: string;
	};
	email?: string;
	iban?: string;
	name?: string;
};

export type CreatePassengerDto = {
	language?: string;
};

export type ConstraintValidationErrorResponseDto = {
	code?: string;
	error?: string;
	message?: string;
	path?: string;
	status?: number;
	validationErrors: {
		[key: string]: Array<string>;
	};
};

export type CheckVehicleDto = {
	assignmentId: string;
	documentsCheck: boolean;
	documentsCheckNotice?: string;
	insideCheck: boolean;
	insideCheckNotice?: string;
	outsideCheck: boolean;
	outsideCheckNotice?: string;
};

export enum CheckInStateEnum {
	NEW = 'NEW',
	CHECKED_IN = 'CHECKED_IN',
	CANCELLED_BY_DRIVER_NO_SHOW = 'CANCELLED_BY_DRIVER_NO_SHOW',
	CANCELLED_BY_DRIVER_WRONG_PASSENGER_NAME = 'CANCELLED_BY_DRIVER_WRONG_PASSENGER_NAME',
	CANCELLED_BY_DRIVER_OTHER_REASON = 'CANCELLED_BY_DRIVER_OTHER_REASON',
	CANCELLED_BY_DRIVER_WRONG_BOOKING_INFO = 'CANCELLED_BY_DRIVER_WRONG_BOOKING_INFO',
	CANCELLED_BY_DRIVER_UNCOOPERATIVE_PASSENGER = 'CANCELLED_BY_DRIVER_UNCOOPERATIVE_PASSENGER',
}

export type CheckInPassengerViewV2 = {
	bookingLegId: string;
	schedulerId?: string;
};

export type CheckInPassengerView = {
	bookingId?: string;
	schedulerId?: string;
};

export type CheckInPassengerDtoV2 = {
	bookingLegId: string;
	cancellationDescription?: string;
	cancellationReason?: CheckInStateEnum;
	scheduledLegId: string;
};

export type CheckInPassengerDto = {
	bookingId: string;
	cancellationDescription?: string;
	cancellationReason?: CheckInStateEnum;
	scheduledLegId: string;
};

export type CapacityCheckSearchDirectionDto = {
	alternativesDirection?: AlternativesDirectionEnum;
	roundIndex?: number;
};

export type CapacityCheckPatchDto = {
	alternativesDirection?: AlternativesDirectionEnum;
	roundIndex?: number;
	/**
	 * ttl in seconds. After this many seconds, the search is automatically cancelled
	 */
	timeToLive?: number;
};

export type AutosuggestResponse = {
	items?: Array<Item>;
	queryTerms?: Array<string>;
};

export type AddPassengerDetailsDto = {
	city: string;
	dateOfBirth: string;
	firstName: string;
	lastName: string;
	phone: string;
	street: string;
	streetNumber: string;
	zipcode: string;
};

export type CreatePassengerDtoWritable = {
	email: string;
	language?: string;
};

export type PostApiCommandByCmdData = {
	/**
	 * command specific payload as JSON Object
	 */
	body:
		| CommandPayloadAddPassengerDetails
		| CommandPayloadSetAlternateInvoiceAddress
		| CommandPayloadSetDefaultPaymentMethod
		| CommandPayloadDeleteDefaultPaymentMethod
		| CommandPayloadCreateDistributor
		| CommandPayloadUpdateDistributor
		| CommandPayloadSaveLocation
		| CommandPayloadBookJourney
		| CommandPayloadCreateDriver
		| CommandPayloadUpdateDriver
		| CommandPayloadDeleteDriver
		| CommandPayloadSaveDriverFiles
		| CommandPayloadCreateVehicle
		| CommandPayloadUpdateVehicle
		| CommandPayloadDeleteVehicle
		| CommandPayloadCheckVehicle
		| CommandPayloadCreateShift
		| CommandPayloadUpdateShift
		| CommandPayloadDeleteShift
		| CommandPayloadCreateRecurringManualBookingLeg
		| CommandPayloadUpdateRecurringManualBookingLeg
		| CommandPayloadDeleteRecurringManualBookingLeg
		| CommandPayloadCreateCalendarEvent
		| CommandPayloadUpdateCalendarEvent
		| CommandPayloadDeleteCalendarEvent
		| CommandPayloadVerifyEmail
		| CommandPayloadCreateGtfsTripFlexibility
		| CommandPayloadCreateUserPushToken
		| CommandPayloadCreateBookingLegManually
		| CommandPayloadCancelBooking
		| CommandPayloadCanDeleteDefaultPaymentMethod
		| CommandPayloadCreateAssignment
		| CommandPayloadUpdateAssignment
		| CommandPayloadAdjustAssignment
		| CommandPayloadDeleteAssignment
		| CommandPayloadBulkCreateAssignments
		| CommandPayloadStartDrive
		| CommandPayloadEndDrive
		| CommandPayloadEndDriveManually
		| CommandPayloadCheckInPassenger
		| CommandPayloadCarryOutOutsideMopla
		| CommandPayloadUpdateBookingLegNotice
		| CommandPayloadUpdateDriverNotice
		| CommandPayloadTriggerBookingPaymentManually
		| CommandPayloadSetBookingTripToScheduleAutomatically
		| CommandPayloadSetBookingTripsToScheduleAutomatically
		| CommandPayloadSetBookingTripToManualDisposition
		| CommandPayloadManuallyAssignToBookingLeg
		| CommandPayloadCancelBookingForBookingLeg
		| CommandPayloadCreateZone
		| CommandPayloadUpdateZone
		| CommandPayloadDeleteZone
		| CommandPayloadCreateTimeframe
		| CommandPayloadUpdateTimeframe
		| CommandPayloadDeleteTimeframe
		| CommandPayloadCancelSubscription;
	path: {
		/**
		 * name of command to be processed
		 */
		cmd:
			| 'addPassengerDetails'
			| 'setAlternateInvoiceAddress'
			| 'setDefaultPaymentMethod'
			| 'deleteDefaultPaymentMethod'
			| 'createDistributor'
			| 'updateDistributor'
			| 'saveLocation'
			| 'bookJourney'
			| 'createDriver'
			| 'updateDriver'
			| 'deleteDriver'
			| 'saveDriverFiles'
			| 'createVehicle'
			| 'updateVehicle'
			| 'deleteVehicle'
			| 'checkVehicle'
			| 'createCalendarEvent'
			| 'updateCalendarEvent'
			| 'deleteCalendarEvent'
			| 'createShift'
			| 'updateShift'
			| 'deleteShift'
			| 'createRecurringManualBookingLeg'
			| 'updateRecurringManualBookingLeg'
			| 'deleteRecurringManualBookingLeg'
			| 'verifyEmail'
			| 'createGtfsTripFlexibility'
			| 'createUserPushToken'
			| 'createBookingLegManually'
			| 'cancelBooking'
			| 'canDeleteDefaultPaymentMethod'
			| 'createAssignment'
			| 'updateAssignment'
			| 'adjustAssignment'
			| 'deleteAssignment'
			| 'bulkCreateAssignments'
			| 'startDrive'
			| 'endDrive'
			| 'endDriveManually'
			| 'checkInPassenger'
			| 'carryOutOutsideMopla'
			| 'updateBookingLegNotice'
			| 'updateDriverNotice'
			| 'triggerBookingPaymentManually'
			| 'setBookingTripToScheduleAutomatically'
			| 'setBookingTripsToScheduleAutomatically'
			| 'setBookingTripToManualDisposition'
			| 'manuallyAssignToBookingLeg'
			| 'cancelBookingForBookingLeg'
			| 'createZone'
			| 'updateZone'
			| 'deleteZone'
			| 'createTimeframe'
			| 'updateTimeframe'
			| 'deleteTimeframe';
	};
	query?: never;
	url: '/api/command/{cmd}';
};

export type PostApiCommandByCmdErrors = {
	/**
	 * Unauthorized
	 */
	401: unknown;
	/**
	 * Forbidden
	 */
	403:
		| {
				/**
				 * distributor company name
				 */
				distributorCompanyName?: string;
				/**
				 * distributor contact email is needed only when user is blacklisted and tries to book the journey
				 */
				distributorContactEmail?: string;
				/**
				 * error message
				 */
				message?: string;
				/**
				 * request uri
				 */
				path?: string;
				/**
				 * http status
				 */
				status?: number;
		  }
		| {
				[key: string]: unknown;
		  };
	/**
	 * Not Found
	 */
	404: unknown;
	/**
	 * Command not processable exception
	 */
	422: unknown;
};

export type PostApiCommandByCmdError =
	PostApiCommandByCmdErrors[keyof PostApiCommandByCmdErrors];

export type PostApiCommandByCmdResponses = {
	/**
	 * uuid
	 */
	200: string;
	/**
	 * Created
	 */
	201: unknown;
	/**
	 * Success without return value
	 */
	204: void;
};

export type PostApiCommandByCmdResponse =
	PostApiCommandByCmdResponses[keyof PostApiCommandByCmdResponses];

export type GetLbodtFlexDistributorInfoBySearchIdData = {
	body?: never;
	path: {
		searchId: string;
	};
	query?: never;
	url: '/api/distributor/info/lbodt-flex/search-id/{searchId}';
};

export type GetLbodtFlexDistributorInfoBySearchIdErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
	/**
	 * Exception: MethodArgumentTypeMismatchException
	 */
	422: ErrorResponseDto;
};

export type GetLbodtFlexDistributorInfoBySearchIdError =
	GetLbodtFlexDistributorInfoBySearchIdErrors[keyof GetLbodtFlexDistributorInfoBySearchIdErrors];

export type GetLbodtFlexDistributorInfoBySearchIdResponses = {
	/**
	 * OK
	 */
	200: LbodtFlexDistributorInfoView;
};

export type GetLbodtFlexDistributorInfoBySearchIdResponse =
	GetLbodtFlexDistributorInfoBySearchIdResponses[keyof GetLbodtFlexDistributorInfoBySearchIdResponses];

export type GetProdtDistributorInfoBySearchIdData = {
	body?: never;
	path: {
		searchId: string;
	};
	query?: never;
	url: '/api/distributor/info/prodt/search-id/{searchId}';
};

export type GetProdtDistributorInfoBySearchIdErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
	/**
	 * Exception: MethodArgumentTypeMismatchException
	 */
	422: ErrorResponseDto;
};

export type GetProdtDistributorInfoBySearchIdError =
	GetProdtDistributorInfoBySearchIdErrors[keyof GetProdtDistributorInfoBySearchIdErrors];

export type GetProdtDistributorInfoBySearchIdResponses = {
	/**
	 * OK
	 */
	200: ProdtDistributorInfoView;
};

export type GetProdtDistributorInfoBySearchIdResponse =
	GetProdtDistributorInfoBySearchIdResponses[keyof GetProdtDistributorInfoBySearchIdResponses];

export type GetPublicTransportInfoData = {
	body?: never;
	path: {
		agencyName: string;
	};
	query?: never;
	url: '/api/distributor/info/public-transport/agency-name/{agencyName}';
};

export type GetPublicTransportInfoErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type GetPublicTransportInfoError =
	GetPublicTransportInfoErrors[keyof GetPublicTransportInfoErrors];

export type GetPublicTransportInfoResponses = {
	/**
	 * OK
	 */
	200: PublicTransportDistributorInfoView;
};

export type GetPublicTransportInfoResponse =
	GetPublicTransportInfoResponses[keyof GetPublicTransportInfoResponses];

export type GetPublicTransportInfoByLegIdData = {
	body?: never;
	path: {
		'bookingleg-id': string;
	};
	query?: never;
	url: '/api/distributor/info/public-transport/bookingleg-id/{bookingleg-id}';
};

export type GetPublicTransportInfoByLegIdErrors = {
	/**
	 * Exception: IllegalArgumentException
	 */
	400: ErrorResponseDto;
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type GetPublicTransportInfoByLegIdError =
	GetPublicTransportInfoByLegIdErrors[keyof GetPublicTransportInfoByLegIdErrors];

export type GetPublicTransportInfoByLegIdResponses = {
	/**
	 * OK
	 */
	200: PublicTransportDistributorInfoView;
};

export type GetPublicTransportInfoByLegIdResponse =
	GetPublicTransportInfoByLegIdResponses[keyof GetPublicTransportInfoByLegIdResponses];

export type GetPublicTransportInfoByDistIdData = {
	body?: never;
	path: {
		'distributor-id': string;
	};
	query?: never;
	url: '/api/distributor/info/public-transport/{distributor-id}';
};

export type GetPublicTransportInfoByDistIdErrors = {
	/**
	 * Exception: IllegalArgumentException
	 */
	400: ErrorResponseDto;
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type GetPublicTransportInfoByDistIdError =
	GetPublicTransportInfoByDistIdErrors[keyof GetPublicTransportInfoByDistIdErrors];

export type GetPublicTransportInfoByDistIdResponses = {
	/**
	 * OK
	 */
	200: PublicTransportDistributorInfoView;
};

export type GetPublicTransportInfoByDistIdResponse =
	GetPublicTransportInfoByDistIdResponses[keyof GetPublicTransportInfoByDistIdResponses];

export type GetDriversData = {
	body?: never;
	path?: never;
	query?: {
		isArchived?: boolean;
		query?: string;
		driverLicenses?: string;
		hasFailedCheck?: boolean;
		/**
		 * Zero-based page index (0..N)
		 */
		page?: number;
		/**
		 * The size of the page to be returned
		 */
		size?: number;
		/**
		 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
		 */
		sort?: Array<string>;
	};
	url: '/api/drivers';
};

export type GetDriversErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type GetDriversError = GetDriversErrors[keyof GetDriversErrors];

export type GetDriversResponses = {
	/**
	 * OK
	 */
	200: DriverMasterViewPage;
};

export type GetDriversResponse = GetDriversResponses[keyof GetDriversResponses];

export type GetBookingLegsData = {
	body: Array<string>;
	path?: never;
	query?: never;
	url: '/api/drivers/bookingLegs';
};

export type GetBookingLegsErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type GetBookingLegsError =
	GetBookingLegsErrors[keyof GetBookingLegsErrors];

export type GetBookingLegsResponses = {
	/**
	 * OK
	 */
	200: Array<DriverBookingLegDetailView>;
};

export type GetBookingLegsResponse =
	GetBookingLegsResponses[keyof GetBookingLegsResponses];

export type CheckInPassengerData = {
	body: CheckInPassengerDto;
	path?: never;
	query?: never;
	url: '/api/drivers/checkInPassenger';
};

export type CheckInPassengerErrors = {
	/**
	 * Exception: InvalidRequestBodyException
	 */
	400: ErrorResponseDto;
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
	/**
	 * Exception: RequestNotProcessableException
	 */
	422: ErrorResponseDto;
};

export type CheckInPassengerError =
	CheckInPassengerErrors[keyof CheckInPassengerErrors];

export type CheckInPassengerResponses = {
	/**
	 * OK
	 */
	200: CheckInPassengerView;
};

export type CheckInPassengerResponse =
	CheckInPassengerResponses[keyof CheckInPassengerResponses];

export type GetEmergencyCallData = {
	body?: never;
	path?: never;
	query?: never;
	url: '/api/drivers/emergencyCall';
};

export type GetEmergencyCallErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type GetEmergencyCallError =
	GetEmergencyCallErrors[keyof GetEmergencyCallErrors];

export type GetEmergencyCallResponses = {
	/**
	 * OK
	 */
	200: EmergencyCallStateEnum;
};

export type GetEmergencyCallResponse =
	GetEmergencyCallResponses[keyof GetEmergencyCallResponses];

export type ActivateEmergencyCallData = {
	body?: never;
	path?: never;
	query?: never;
	url: '/api/drivers/emergencyCall/activate';
};

export type ActivateEmergencyCallErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type ActivateEmergencyCallError =
	ActivateEmergencyCallErrors[keyof ActivateEmergencyCallErrors];

export type ActivateEmergencyCallResponses = {
	/**
	 * No Content
	 */
	204: {
		[key: string]: unknown;
	};
};

export type ActivateEmergencyCallResponse =
	ActivateEmergencyCallResponses[keyof ActivateEmergencyCallResponses];

export type DeactivateEmergencyCallData = {
	body?: never;
	path?: never;
	query?: never;
	url: '/api/drivers/emergencyCall/deactivate';
};

export type DeactivateEmergencyCallErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type DeactivateEmergencyCallError =
	DeactivateEmergencyCallErrors[keyof DeactivateEmergencyCallErrors];

export type DeactivateEmergencyCallResponses = {
	/**
	 * No Content
	 */
	204: {
		[key: string]: unknown;
	};
};

export type DeactivateEmergencyCallResponse =
	DeactivateEmergencyCallResponses[keyof DeactivateEmergencyCallResponses];

export type StoreDriverLocationData = {
	body: SaveDriverLocationDto;
	path?: never;
	query?: never;
	url: '/api/drivers/location';
};

export type StoreDriverLocationErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type StoreDriverLocationError =
	StoreDriverLocationErrors[keyof StoreDriverLocationErrors];

export type StoreDriverLocationResponses = {
	/**
	 * OK
	 */
	200: Location;
};

export type StoreDriverLocationResponse =
	StoreDriverLocationResponses[keyof StoreDriverLocationResponses];

export type GetDriverMapsData = {
	body?: never;
	path?: never;
	query?: never;
	url: '/api/drivers/map';
};

export type GetDriverMapsErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Exception: NoPermissionException
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type GetDriverMapsError = GetDriverMapsErrors[keyof GetDriverMapsErrors];

export type GetDriverMapsResponses = {
	/**
	 * OK
	 */
	200: Array<DriverMapView>;
};

export type GetDriverMapsResponse =
	GetDriverMapsResponses[keyof GetDriverMapsResponses];

export type GetCurrentScheduleData = {
	body?: never;
	path?: never;
	query?: never;
	url: '/api/drivers/schedule';
};

export type GetCurrentScheduleErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type GetCurrentScheduleError =
	GetCurrentScheduleErrors[keyof GetCurrentScheduleErrors];

export type GetCurrentScheduleResponses = {
	/**
	 * OK
	 */
	200: DriverScheduleView;
};

export type GetCurrentScheduleResponse =
	GetCurrentScheduleResponses[keyof GetCurrentScheduleResponses];

export type ToggleArchivation2Data = {
	body: Array<string>;
	path?: never;
	query?: never;
	url: '/api/drivers/toggleArchivation';
};

export type ToggleArchivation2Errors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Exception: NoPermissionException
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type ToggleArchivation2Error =
	ToggleArchivation2Errors[keyof ToggleArchivation2Errors];

export type ToggleArchivation2Responses = {
	/**
	 * OK
	 */
	200: Array<string>;
};

export type ToggleArchivation2Response =
	ToggleArchivation2Responses[keyof ToggleArchivation2Responses];

export type CheckInPassengerV2Data = {
	body: CheckInPassengerDtoV2;
	path?: never;
	query?: never;
	url: '/api/drivers/v2/checkInPassenger';
};

export type CheckInPassengerV2Errors = {
	/**
	 * Exception: InvalidRequestBodyException
	 */
	400: ErrorResponseDto;
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
	/**
	 * Exception: RequestNotProcessableException
	 */
	422: ErrorResponseDto;
};

export type CheckInPassengerV2Error =
	CheckInPassengerV2Errors[keyof CheckInPassengerV2Errors];

export type CheckInPassengerV2Responses = {
	/**
	 * OK
	 */
	200: CheckInPassengerViewV2;
};

export type CheckInPassengerV2Response =
	CheckInPassengerV2Responses[keyof CheckInPassengerV2Responses];

export type GetDriverData = {
	body?: never;
	path: {
		driverid: string;
	};
	query?: never;
	url: '/api/drivers/{driverid}';
};

export type GetDriverErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type GetDriverError = GetDriverErrors[keyof GetDriverErrors];

export type GetDriverResponses = {
	/**
	 * OK
	 */
	200: DriverDetailView;
};

export type GetDriverResponse = GetDriverResponses[keyof GetDriverResponses];

export type GetEmailStatusData = {
	body?: never;
	path?: never;
	query: {
		email: string;
	};
	url: '/api/emails/check';
};

export type GetEmailStatusErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
};

export type GetEmailStatusError =
	GetEmailStatusErrors[keyof GetEmailStatusErrors];

export type GetEmailStatusResponses = {
	/**
	 * OK
	 */
	200: EmailValidationDto;
};

export type GetEmailStatusResponse =
	GetEmailStatusResponses[keyof GetEmailStatusResponses];

export type GetFeedbacksTableData = {
	body?: never;
	path?: never;
	query?: {
		query?: string;
		ratings?: Array<number>;
		drivers?: Array<string>;
		/**
		 * Zero-based page index (0..N)
		 */
		page?: number;
		/**
		 * The size of the page to be returned
		 */
		size?: number;
		/**
		 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
		 */
		sort?: Array<string>;
	};
	url: '/api/feedback';
};

export type GetFeedbacksTableErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Exception: NoPermissionException
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type GetFeedbacksTableError =
	GetFeedbacksTableErrors[keyof GetFeedbacksTableErrors];

export type GetFeedbacksTableResponses = {
	/**
	 * OK
	 */
	200: PageFeedbackSummaryDto;
};

export type GetFeedbacksTableResponse =
	GetFeedbacksTableResponses[keyof GetFeedbacksTableResponses];

export type GetFeedbacksByBookingLegData = {
	body?: never;
	path: {
		bookingLegId: string;
	};
	query?: never;
	url: '/api/feedback/by-booking-leg/{bookingLegId}';
};

export type GetFeedbacksByBookingLegErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
};

export type GetFeedbacksByBookingLegError =
	GetFeedbacksByBookingLegErrors[keyof GetFeedbacksByBookingLegErrors];

export type GetFeedbacksByBookingLegResponses = {
	/**
	 * OK
	 */
	200: FeedbackForBookingDto;
};

export type GetFeedbacksByBookingLegResponse =
	GetFeedbacksByBookingLegResponses[keyof GetFeedbacksByBookingLegResponses];

export type GetFeedbacksByBookingData = {
	body?: never;
	path: {
		bookingId: string;
	};
	query?: never;
	url: '/api/feedback/by-booking/{bookingId}';
};

export type GetFeedbacksByBookingErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
};

export type GetFeedbacksByBookingError =
	GetFeedbacksByBookingErrors[keyof GetFeedbacksByBookingErrors];

export type GetFeedbacksByBookingResponses = {
	/**
	 * OK
	 */
	200: Array<FeedbackForBookingDto>;
};

export type GetFeedbacksByBookingResponse =
	GetFeedbacksByBookingResponses[keyof GetFeedbacksByBookingResponses];

export type GetFeedbacksByDriverData = {
	body?: never;
	path: {
		driverId: string;
	};
	query?: never;
	url: '/api/feedback/by-driver/{driverId}';
};

export type GetFeedbacksByDriverErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type GetFeedbacksByDriverError =
	GetFeedbacksByDriverErrors[keyof GetFeedbacksByDriverErrors];

export type GetFeedbacksByDriverResponses = {
	/**
	 * OK
	 */
	200: Array<FeedbackForBookingDto>;
};

export type GetFeedbacksByDriverResponse =
	GetFeedbacksByDriverResponses[keyof GetFeedbacksByDriverResponses];

export type GetFeedbacksByUserData = {
	body?: never;
	path: {
		userId: string;
	};
	query?: never;
	url: '/api/feedback/by-user/{userId}';
};

export type GetFeedbacksByUserErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
};

export type GetFeedbacksByUserError =
	GetFeedbacksByUserErrors[keyof GetFeedbacksByUserErrors];

export type GetFeedbacksByUserResponses = {
	/**
	 * OK
	 */
	200: Array<FeedbackForBookingDto>;
};

export type GetFeedbacksByUserResponse =
	GetFeedbacksByUserResponses[keyof GetFeedbacksByUserResponses];

export type GetDriverAndCarDetailsData = {
	body?: never;
	path: {
		bookingLegId: string;
	};
	query?: never;
	url: '/api/feedback/driver-car-details/{bookingLegId}';
};

export type GetDriverAndCarDetailsErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type GetDriverAndCarDetailsError =
	GetDriverAndCarDetailsErrors[keyof GetDriverAndCarDetailsErrors];

export type GetDriverAndCarDetailsResponses = {
	/**
	 * OK
	 */
	200: DriverCarDetailsDto;
};

export type GetDriverAndCarDetailsResponse =
	GetDriverAndCarDetailsResponses[keyof GetDriverAndCarDetailsResponses];

export type GetDriverLicenceFileData = {
	body?: never;
	path: {
		fileuuid: string;
	};
	query?: never;
	url: '/api/files/driver-licence/download/{fileuuid}';
};

export type GetDriverLicenceFileErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Exception: NoPermissionException
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
	/**
	 * Exception: RequestCurrentResourceConflictException
	 */
	409: ErrorResponseDto;
};

export type GetDriverLicenceFileError =
	GetDriverLicenceFileErrors[keyof GetDriverLicenceFileErrors];

export type GetDriverLicenceFileResponses = {
	/**
	 * OK
	 */
	200: string;
};

export type GetDriverLicenceFileResponse =
	GetDriverLicenceFileResponses[keyof GetDriverLicenceFileResponses];

export type HandleDriverLicenceUploadData = {
	body?: {
		file: Blob | File;
	};
	path?: never;
	query?: never;
	url: '/api/files/driver-licence/upload';
};

export type HandleDriverLicenceUploadErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
	/**
	 * Exception: RequestNotProcessableException
	 */
	422: ErrorResponseDto;
};

export type HandleDriverLicenceUploadError =
	HandleDriverLicenceUploadErrors[keyof HandleDriverLicenceUploadErrors];

export type HandleDriverLicenceUploadResponses = {
	/**
	 * OK
	 */
	200: FileLinkView;
};

export type HandleDriverLicenceUploadResponse =
	HandleDriverLicenceUploadResponses[keyof HandleDriverLicenceUploadResponses];

export type HereApiCallData = {
	body?: never;
	path?: never;
	query: {
		q: string;
		result_types?: string;
		at: string;
	};
	url: '/api/here/autosuggest';
};

export type HereApiCallErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
};

export type HereApiCallError = HereApiCallErrors[keyof HereApiCallErrors];

export type HereApiCallResponses = {
	/**
	 * OK
	 */
	200: AutosuggestResponse;
};

export type HereApiCallResponse =
	HereApiCallResponses[keyof HereApiCallResponses];

export type LookupApiCallData = {
	body?: never;
	path?: never;
	query: {
		id: string;
	};
	url: '/api/here/lookup';
};

export type LookupApiCallErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type LookupApiCallError = LookupApiCallErrors[keyof LookupApiCallErrors];

export type LookupApiCallResponses = {
	/**
	 * OK
	 */
	200: LookupResponse;
};

export type LookupApiCallResponse =
	LookupApiCallResponses[keyof LookupApiCallResponses];

export type SendPushNotificationData = {
	body: TriggerNotificationDto;
	path?: never;
	query?: never;
	url: '/api/notifications/send';
};

export type SendPushNotificationErrors = {
	/**
	 * notification is not sent
	 */
	400: {
		[key: string]: unknown;
	};
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
	/**
	 * Exception: CommandNotProcessableException
	 */
	422: ErrorResponseDto;
};

export type SendPushNotificationError =
	SendPushNotificationErrors[keyof SendPushNotificationErrors];

export type SendPushNotificationResponses = {
	/**
	 * notification is sent
	 */
	204: {
		[key: string]: unknown;
	};
};

export type SendPushNotificationResponse =
	SendPushNotificationResponses[keyof SendPushNotificationResponses];

export type GetAppleWalletPassData = {
	body?: never;
	path?: never;
	query: {
		ticketId: string;
	};
	url: '/api/passengers/appleWalletPass';
};

export type GetAppleWalletPassErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
	/**
	 * Exception: IOException
	 */
	422: ErrorResponseDto;
};

export type GetAppleWalletPassError =
	GetAppleWalletPassErrors[keyof GetAppleWalletPassErrors];

export type GetAppleWalletPassResponses = {
	/**
	 * Apple Wallet pkpass
	 */
	200: string;
};

export type GetAppleWalletPassResponse =
	GetAppleWalletPassResponses[keyof GetAppleWalletPassResponses];

export type GetBookingsData = {
	body?: never;
	path?: never;
	query?: never;
	url: '/api/passengers/bookings';
};

export type GetBookingsErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type GetBookingsError = GetBookingsErrors[keyof GetBookingsErrors];

export type GetBookingsResponses = {
	/**
	 * OK
	 */
	200: Array<PassengerBookingView>;
};

export type GetBookingsResponse =
	GetBookingsResponses[keyof GetBookingsResponses];

export type GetDriverLocationData = {
	body?: never;
	path: {
		uuid: string;
	};
	query?: never;
	url: '/api/passengers/bookings/{uuid}/map';
};

export type GetDriverLocationErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
	/**
	 * Exception: RequestNotProcessableException
	 */
	422: ErrorResponseDto;
};

export type GetDriverLocationError =
	GetDriverLocationErrors[keyof GetDriverLocationErrors];

export type GetDriverLocationResponses = {
	/**
	 * OK
	 */
	200: DriverLocationPassengerMapDto;
	/**
	 * No Content
	 */
	204: {
		[key: string]: unknown;
	};
};

export type GetDriverLocationResponse =
	GetDriverLocationResponses[keyof GetDriverLocationResponses];

export type CanDeleteAccountData = {
	body?: never;
	path?: never;
	query?: never;
	url: '/api/passengers/canDeleteAccount';
};

export type CanDeleteAccountErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type CanDeleteAccountError =
	CanDeleteAccountErrors[keyof CanDeleteAccountErrors];

export type CanDeleteAccountResponses = {
	/**
	 * OK
	 */
	200: PassengerCanBeDeletedView;
};

export type CanDeleteAccountResponse =
	CanDeleteAccountResponses[keyof CanDeleteAccountResponses];

export type CreatePassengerData = {
	body: CreatePassengerDtoWritable;
	path?: never;
	query?: never;
	url: '/api/passengers/create';
};

export type CreatePassengerErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Exception: BannedEmailDomainException, UserIsBlacklistedException
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
	/**
	 * Exception: UserAlreadyExistsException
	 */
	409: ErrorResponseDto;
	/**
	 * Exception: RequestNotProcessableException
	 */
	422: ErrorResponseDto;
};

export type CreatePassengerError =
	CreatePassengerErrors[keyof CreatePassengerErrors];

export type CreatePassengerResponses = {
	/**
	 * OK
	 */
	200: UserNewlyCreatedView;
};

export type CreatePassengerResponse =
	CreatePassengerResponses[keyof CreatePassengerResponses];

export type DeleteDefaultPaymentMethodData = {
	body?: never;
	path?: never;
	query?: never;
	url: '/api/passengers/defaultPaymentMethod';
};

export type DeleteDefaultPaymentMethodErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type DeleteDefaultPaymentMethodError =
	DeleteDefaultPaymentMethodErrors[keyof DeleteDefaultPaymentMethodErrors];

export type DeleteDefaultPaymentMethodResponses = {
	/**
	 * OK
	 */
	200: string;
};

export type DeleteDefaultPaymentMethodResponse =
	DeleteDefaultPaymentMethodResponses[keyof DeleteDefaultPaymentMethodResponses];

export type GetDefaultPaymentMethodData = {
	body?: never;
	path?: never;
	query?: never;
	url: '/api/passengers/defaultPaymentMethod';
};

export type GetDefaultPaymentMethodErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type GetDefaultPaymentMethodError =
	GetDefaultPaymentMethodErrors[keyof GetDefaultPaymentMethodErrors];

export type GetDefaultPaymentMethodResponses = {
	/**
	 * OK
	 */
	200: {
		[key: string]: unknown;
	};
};

export type GetDefaultPaymentMethodResponse =
	GetDefaultPaymentMethodResponses[keyof GetDefaultPaymentMethodResponses];

export type SetDefaultPaymentMethodData = {
	body: SetDefaultPaymentMethodDto;
	path?: never;
	query?: never;
	url: '/api/passengers/defaultPaymentMethod';
};

export type SetDefaultPaymentMethodErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
	/**
	 * Exception: CommandNotProcessableException
	 */
	422: ErrorResponseDto;
};

export type SetDefaultPaymentMethodError =
	SetDefaultPaymentMethodErrors[keyof SetDefaultPaymentMethodErrors];

export type SetDefaultPaymentMethodResponses = {
	/**
	 * OK
	 */
	200: string;
};

export type SetDefaultPaymentMethodResponse =
	SetDefaultPaymentMethodResponses[keyof SetDefaultPaymentMethodResponses];

export type CanDeleteDefaultPaymentMethodData = {
	body?: never;
	path?: never;
	query?: never;
	url: '/api/passengers/defaultPaymentMethod/canDelete';
};

export type CanDeleteDefaultPaymentMethodErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type CanDeleteDefaultPaymentMethodError =
	CanDeleteDefaultPaymentMethodErrors[keyof CanDeleteDefaultPaymentMethodErrors];

export type CanDeleteDefaultPaymentMethodResponses = {
	/**
	 * OK
	 */
	200: PassengerCanDeleteDefaultPaymentMethodView;
};

export type CanDeleteDefaultPaymentMethodResponse =
	CanDeleteDefaultPaymentMethodResponses[keyof CanDeleteDefaultPaymentMethodResponses];

export type DeletePassengerData = {
	body?: never;
	path?: never;
	query?: never;
	url: '/api/passengers/delete';
};

export type DeletePassengerErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
	/**
	 * Exception: RequestCurrentResourceConflictException
	 */
	409: ErrorResponseDto;
};

export type DeletePassengerError =
	DeletePassengerErrors[keyof DeletePassengerErrors];

export type DeletePassengerResponses = {
	/**
	 * OK
	 */
	200: UserNewlyCreatedView;
};

export type DeletePassengerResponse =
	DeletePassengerResponses[keyof DeletePassengerResponses];

export type DeleteTokenData = {
	body?: never;
	path?: never;
	query?: never;
	url: '/api/passengers/deleteTokens';
};

export type DeleteTokenErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type DeleteTokenError = DeleteTokenErrors[keyof DeleteTokenErrors];

export type DeleteTokenResponses = {
	/**
	 * OK
	 */
	200: unknown;
};

export type AddPassengerDetailsData = {
	body: AddPassengerDetailsDto;
	path?: never;
	query?: never;
	url: '/api/passengers/details';
};

export type AddPassengerDetailsErrors = {
	/**
	 * Invalid input (Validation failed)
	 */
	400: ConstraintValidationErrorResponseDto;
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Exception: NoPermissionException
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type AddPassengerDetailsError =
	AddPassengerDetailsErrors[keyof AddPassengerDetailsErrors];

export type AddPassengerDetailsResponses = {
	/**
	 * Details updated successfully
	 */
	200: string;
};

export type AddPassengerDetailsResponse =
	AddPassengerDetailsResponses[keyof AddPassengerDetailsResponses];

export type GetDigitalBonusData = {
	body?: never;
	path?: never;
	query?: never;
	url: '/api/passengers/digitalBonus';
};

export type GetDigitalBonusErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type GetDigitalBonusError =
	GetDigitalBonusErrors[keyof GetDigitalBonusErrors];

export type GetDigitalBonusResponses = {
	/**
	 * OK
	 */
	200: DigitalBonusView;
};

export type GetDigitalBonusResponse =
	GetDigitalBonusResponses[keyof GetDigitalBonusResponses];

export type GiveFeedbackForJourneyData = {
	body: GiveFeedbackForBookingDto;
	path?: never;
	query: {
		bookingId: string;
	};
	url: '/api/passengers/feedbackJourney';
};

export type GiveFeedbackForJourneyErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
	/**
	 * Exception: RequestNotProcessableException
	 */
	422: ErrorResponseDto;
};

export type GiveFeedbackForJourneyError =
	GiveFeedbackForJourneyErrors[keyof GiveFeedbackForJourneyErrors];

export type GiveFeedbackForJourneyResponses = {
	/**
	 * OK
	 */
	200: unknown;
};

export type GetData = {
	body?: never;
	path?: never;
	query?: never;
	url: '/api/passengers/germanyTicketSubscriptionOffering';
};

export type GetErrors = {
	/**
	 * Exception: ExpiredVoucherException
	 */
	400: ErrorResponseDto;
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type GetError = GetErrors[keyof GetErrors];

export type GetResponses = {
	/**
	 * OK
	 */
	200: GermanyTicketSubscriptionOfferingView;
};

export type GetResponse = GetResponses[keyof GetResponses];

export type GetGoogleWalletData = {
	body?: never;
	path?: never;
	query: {
		ticketId: string;
	};
	url: '/api/passengers/googleWallet';
};

export type GetGoogleWalletErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
	/**
	 * Exception: IOException
	 */
	422: ErrorResponseDto;
};

export type GetGoogleWalletError =
	GetGoogleWalletErrors[keyof GetGoogleWalletErrors];

export type GetGoogleWalletResponses = {
	/**
	 * Google Wallet view
	 */
	200: GoogleWalletView;
};

export type GetGoogleWalletResponse =
	GetGoogleWalletResponses[keyof GetGoogleWalletResponses];

export type HasVoucherRemeededData = {
	body?: never;
	path?: never;
	query?: never;
	url: '/api/passengers/hasVoucherRedeemed';
};

export type HasVoucherRemeededErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type HasVoucherRemeededError =
	HasVoucherRemeededErrors[keyof HasVoucherRemeededErrors];

export type HasVoucherRemeededResponses = {
	/**
	 * OK
	 */
	200: {
		[key: string]: unknown;
	};
};

export type HasVoucherRemeededResponse =
	HasVoucherRemeededResponses[keyof HasVoucherRemeededResponses];

export type GetNewIntentData = {
	body?: never;
	path?: never;
	query?: never;
	url: '/api/passengers/intent';
};

export type GetNewIntentErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type GetNewIntentError = GetNewIntentErrors[keyof GetNewIntentErrors];

export type GetNewIntentResponses = {
	/**
	 * OK
	 */
	200: NewSetupIntentView;
};

export type GetNewIntentResponse =
	GetNewIntentResponses[keyof GetNewIntentResponses];

export type GetAvailableInvoicesData = {
	body?: never;
	path?: never;
	query?: {
		subscriptionId?: string;
	};
	url: '/api/passengers/invoices';
};

export type GetAvailableInvoicesErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type GetAvailableInvoicesError =
	GetAvailableInvoicesErrors[keyof GetAvailableInvoicesErrors];

export type GetAvailableInvoicesResponses = {
	/**
	 * OK
	 */
	200: Array<SubscriptionIdYearMonthView>;
};

export type GetAvailableInvoicesResponse =
	GetAvailableInvoicesResponses[keyof GetAvailableInvoicesResponses];

export type SendInvoiceEmailForGermanyTicketData = {
	body: SendInvoiceEmailDto;
	path?: never;
	query?: never;
	url: '/api/passengers/invoices';
};

export type SendInvoiceEmailForGermanyTicketErrors = {
	/**
	 * Exception: InvalidCommandException
	 */
	400: ErrorResponseDto;
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type SendInvoiceEmailForGermanyTicketError =
	SendInvoiceEmailForGermanyTicketErrors[keyof SendInvoiceEmailForGermanyTicketErrors];

export type SendInvoiceEmailForGermanyTicketResponses = {
	/**
	 * OK
	 */
	200: unknown;
};

export type SetAlternateInvoiceAddressData = {
	body: SetAlternateInvoiceAddressDto;
	path?: never;
	query?: never;
	url: '/api/passengers/invoices/address';
};

export type SetAlternateInvoiceAddressErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type SetAlternateInvoiceAddressError =
	SetAlternateInvoiceAddressErrors[keyof SetAlternateInvoiceAddressErrors];

export type SetAlternateInvoiceAddressResponses = {
	/**
	 * OK
	 */
	200: string;
};

export type SetAlternateInvoiceAddressResponse =
	SetAlternateInvoiceAddressResponses[keyof SetAlternateInvoiceAddressResponses];

export type SendInvoiceEmailForBookingData = {
	body?: never;
	path?: never;
	query: {
		id: string;
	};
	url: '/api/passengers/invoices/booking';
};

export type SendInvoiceEmailForBookingErrors = {
	/**
	 * Exception: InvalidCommandException
	 */
	400: ErrorResponseDto;
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type SendInvoiceEmailForBookingError =
	SendInvoiceEmailForBookingErrors[keyof SendInvoiceEmailForBookingErrors];

export type SendInvoiceEmailForBookingResponses = {
	/**
	 * OK
	 */
	200: unknown;
};

export type GetPaymentMethodSetupStatusData = {
	body?: never;
	path?: never;
	query?: never;
	url: '/api/passengers/paymentMethodSetupStatus';
};

export type GetPaymentMethodSetupStatusErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type GetPaymentMethodSetupStatusError =
	GetPaymentMethodSetupStatusErrors[keyof GetPaymentMethodSetupStatusErrors];

export type GetPaymentMethodSetupStatusResponses = {
	/**
	 * OK
	 */
	200: PaymentMethodSetupStatusView;
};

export type GetPaymentMethodSetupStatusResponse =
	GetPaymentMethodSetupStatusResponses[keyof GetPaymentMethodSetupStatusResponses];

export type RemoveBookingData = {
	body?: never;
	path?: never;
	query: {
		bookingId: string;
	};
	url: '/api/passengers/removeBooking';
};

export type RemoveBookingErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type RemoveBookingError = RemoveBookingErrors[keyof RemoveBookingErrors];

export type RemoveBookingResponses = {
	/**
	 * OK
	 */
	200: unknown;
};

export type CreateSubscriptionData = {
	body: SubscriptionCreateDto;
	path?: never;
	query?: never;
	url: '/api/passengers/subscription/create';
};

export type CreateSubscriptionErrors = {
	/**
	 * Exception: InvalidCaptchaException
	 */
	400: ErrorResponseDto;
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
	/**
	 * Exception: CaptchaAlreadyValidatedException
	 */
	409: ErrorResponseDto;
	/**
	 * Exception: CommandNotProcessableException
	 */
	422: ErrorResponseDto;
};

export type CreateSubscriptionError =
	CreateSubscriptionErrors[keyof CreateSubscriptionErrors];

export type CreateSubscriptionResponses = {
	/**
	 * OK
	 */
	200: unknown;
};

export type CancelCancellationData = {
	body?: never;
	path: {
		subscriptionId: string;
	};
	query?: never;
	url: '/api/passengers/subscription/{subscriptionId}/cancellation';
};

export type CancelCancellationErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type CancelCancellationError =
	CancelCancellationErrors[keyof CancelCancellationErrors];

export type CancelCancellationResponses = {
	/**
	 * OK
	 */
	200: unknown;
};

export type GetSubscriptionsData = {
	body?: never;
	path?: never;
	query?: never;
	url: '/api/passengers/subscriptions';
};

export type GetSubscriptionsErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type GetSubscriptionsError =
	GetSubscriptionsErrors[keyof GetSubscriptionsErrors];

export type GetSubscriptionsResponses = {
	/**
	 * OK
	 */
	200: Array<SubscriptionView>;
};

export type GetSubscriptionsResponse =
	GetSubscriptionsResponses[keyof GetSubscriptionsResponses];

export type GetSyncBookingsData = {
	body?: never;
	path?: never;
	query: {
		bookingId?: string;
		updateTimestamp?: string;
		pageable: Pageable;
	};
	url: '/api/passengers/syncBookings';
};

export type GetSyncBookingsErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type GetSyncBookingsError =
	GetSyncBookingsErrors[keyof GetSyncBookingsErrors];

export type GetSyncBookingsResponses = {
	/**
	 * OK
	 */
	200: PagePassengerBookingView;
};

export type GetSyncBookingsResponse =
	GetSyncBookingsResponses[keyof GetSyncBookingsResponses];

export type GetTicketsData = {
	body?: never;
	path?: never;
	query?: never;
	url: '/api/passengers/tickets';
};

export type GetTicketsErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
};

export type GetTicketsError = GetTicketsErrors[keyof GetTicketsErrors];

export type GetTicketsResponses = {
	/**
	 * OK
	 */
	200: Array<TicketView>;
};

export type GetTicketsResponse = GetTicketsResponses[keyof GetTicketsResponses];

export type RegenerateTicketData = {
	body?: never;
	path: {
		userId: string;
	};
	query?: never;
	url: '/api/passengers/tickets/regenerate/{userId}';
};

export type RegenerateTicketErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Exception: NoPermissionException
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type RegenerateTicketError =
	RegenerateTicketErrors[keyof RegenerateTicketErrors];

export type RegenerateTicketResponses = {
	/**
	 * OK
	 */
	200: unknown;
};

export type CalculatePriceData = {
	body: PriceCalculationDto;
	path?: never;
	query?: never;
	url: '/api/pricing/calculate';
};

export type CalculatePriceErrors = {
	/**
	 * Exception: ExpiredVoucherException, VoucherAlreadyUsedException, VoucherIsNotEligibleException, VoucherReachedLimitException, VoucherZoneInvalidException
	 */
	400: ErrorResponseDto;
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type CalculatePriceError =
	CalculatePriceErrors[keyof CalculatePriceErrors];

export type CalculatePriceResponses = {
	/**
	 * OK
	 */
	200: PricingView;
};

export type CalculatePriceResponse =
	CalculatePriceResponses[keyof CalculatePriceResponses];

export type PostCapacityCheckData = {
	body: LbodtflexCapacityCheckRequestDto;
	path?: never;
	query?: never;
	url: '/api/router/lbodtflex/capacitycheck';
};

export type PostCapacityCheckErrors = {
	/**
	 * Exception: InvalidRequestBodyException
	 */
	400: ErrorResponseDto;
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
	/**
	 * Exception: RequestNotProcessableException
	 */
	422: ErrorResponseDto;
};

export type PostCapacityCheckError =
	PostCapacityCheckErrors[keyof PostCapacityCheckErrors];

export type PostCapacityCheckResponses = {
	/**
	 * OK
	 */
	200: LbodtflexCapacityCheckView;
};

export type PostCapacityCheckResponse =
	PostCapacityCheckResponses[keyof PostCapacityCheckResponses];

export type DeleteCapacityCheckData = {
	body?: never;
	path: {
		capacityCheckId: string;
	};
	query?: never;
	url: '/api/router/lbodtflex/capacitycheck/{capacityCheckId}';
};

export type DeleteCapacityCheckErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type DeleteCapacityCheckError =
	DeleteCapacityCheckErrors[keyof DeleteCapacityCheckErrors];

export type DeleteCapacityCheckResponses = {
	/**
	 * No Content
	 */
	204: void;
};

export type DeleteCapacityCheckResponse =
	DeleteCapacityCheckResponses[keyof DeleteCapacityCheckResponses];

export type GetCapacityCheckData = {
	body?: never;
	path: {
		capacityCheckId: string;
	};
	query?: never;
	url: '/api/router/lbodtflex/capacitycheck/{capacityCheckId}';
};

export type GetCapacityCheckErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type GetCapacityCheckError =
	GetCapacityCheckErrors[keyof GetCapacityCheckErrors];

export type GetCapacityCheckResponses = {
	/**
	 * OK
	 */
	200: LbodtflexCapacityCheckView;
};

export type GetCapacityCheckResponse =
	GetCapacityCheckResponses[keyof GetCapacityCheckResponses];

export type PatchCapacityCheck1Data = {
	body: CapacityCheckSearchDirectionDto;
	path: {
		capacityCheckId: string;
	};
	query?: never;
	url: '/api/router/lbodtflex/capacitycheck/{capacityCheckId}';
};

export type PatchCapacityCheck1Errors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
	/**
	 * Exception: RequestNotProcessableException
	 */
	422: ErrorResponseDto;
};

export type PatchCapacityCheck1Error =
	PatchCapacityCheck1Errors[keyof PatchCapacityCheck1Errors];

export type PatchCapacityCheck1Responses = {
	/**
	 * No Content
	 */
	204: void;
};

export type PatchCapacityCheck1Response =
	PatchCapacityCheck1Responses[keyof PatchCapacityCheck1Responses];

export type GetPlanData = {
	body?: never;
	headers?: {
		'Content-Version'?: string;
	};
	path?: never;
	query: {
		fromPlaceLat: string;
		fromPlaceLng: string;
		fromPlaceLabel: string;
		fromPlaceZip: string;
		fromPlaceRegion?: ProvinceEnum;
		toPlaceLat: string;
		toPlaceLng: string;
		toPlaceLabel: string;
		toPlaceZip: string;
		toPlaceRegion?: ProvinceEnum;
		datetime: string;
		arriveBy: boolean;
		specialNeeds: SpecialNeedsEnum;
	};
	url: '/api/router/plan';
};

export type GetPlanErrors = {
	/**
	 * Exception: ZipcodeMismatchException
	 */
	400: ErrorResponseDto;
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Not Found
	 */
	404: ErrorResponseDto;
	/**
	 * Exception: LocationNotFoundInHereResponseException
	 */
	500: ErrorResponseDto;
};

export type GetPlanError = GetPlanErrors[keyof GetPlanErrors];

export type GetPlanResponses = {
	/**
	 * OK
	 */
	200: RouterPlanResponseView;
};

export type GetPlanResponse = GetPlanResponses[keyof GetPlanResponses];

export type GetCheaperTripsData = {
	body?: never;
	headers?: {
		'Content-Version'?: string;
	};
	path?: never;
	query: {
		fromPlaceLat: string;
		fromPlaceLng: string;
		fromPlaceLabel: string;
		fromPlaceZip: string;
		fromPlaceRegion: ProvinceEnum;
		toPlaceLat: string;
		toPlaceLng: string;
		toPlaceLabel: string;
		toPlaceZip: string;
		toPlaceRegion: ProvinceEnum;
		datetime: string;
		arriveBy: boolean;
		specialNeeds: SpecialNeedsEnum;
	};
	url: '/api/router/plan/cheaperTrips';
};

export type GetCheaperTripsErrors = {
	/**
	 * Exception: ZipcodeMismatchException
	 */
	400: ErrorResponseDto;
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
	/**
	 * Exception: LocationNotFoundInHereResponseException
	 */
	500: ErrorResponseDto;
};

export type GetCheaperTripsError =
	GetCheaperTripsErrors[keyof GetCheaperTripsErrors];

export type GetCheaperTripsResponses = {
	/**
	 * OK
	 */
	200: RouterPlanResponseView;
};

export type GetCheaperTripsResponse =
	GetCheaperTripsResponses[keyof GetCheaperTripsResponses];

export type PostSearchData = {
	body: PrivateTripSearchRequestDto;
	path?: never;
	query?: never;
	url: '/api/router/prodt/search';
};

export type PostSearchErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type PostSearchError = PostSearchErrors[keyof PostSearchErrors];

export type PostSearchResponses = {
	/**
	 * OK
	 */
	200: PrivateTripSearchView;
};

export type PostSearchResponse = PostSearchResponses[keyof PostSearchResponses];

export type DeleteSearchData = {
	body?: never;
	path: {
		searchId: string;
	};
	query?: never;
	url: '/api/router/prodt/search/{searchId}';
};

export type DeleteSearchErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type DeleteSearchError = DeleteSearchErrors[keyof DeleteSearchErrors];

export type DeleteSearchResponses = {
	/**
	 * No Content
	 */
	204: void;
};

export type DeleteSearchResponse =
	DeleteSearchResponses[keyof DeleteSearchResponses];

export type GetSearchData = {
	body?: never;
	path: {
		searchId: string;
	};
	query?: never;
	url: '/api/router/prodt/search/{searchId}';
};

export type GetSearchErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type GetSearchError = GetSearchErrors[keyof GetSearchErrors];

export type GetSearchResponses = {
	/**
	 * OK
	 */
	200: PrivateTripSearchView;
};

export type GetSearchResponse = GetSearchResponses[keyof GetSearchResponses];

export type PatchSearch1Data = {
	body: CapacityCheckSearchDirectionDto;
	path: {
		searchId: string;
	};
	query?: never;
	url: '/api/router/prodt/search/{searchId}';
};

export type PatchSearch1Errors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type PatchSearch1Error = PatchSearch1Errors[keyof PatchSearch1Errors];

export type PatchSearch1Responses = {
	/**
	 * No Content
	 */
	204: void;
};

export type PatchSearch1Response =
	PatchSearch1Responses[keyof PatchSearch1Responses];

export type RunSchedulerData = {
	body: Array<RunSchedulerDto>;
	path?: never;
	query?: never;
	url: '/api/run-scheduler';
};

export type RunSchedulerErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Exception: RequestNotProcessableException
	 */
	422: ErrorResponseDto;
};

export type RunSchedulerError = RunSchedulerErrors[keyof RunSchedulerErrors];

export type RunSchedulerResponses = {
	/**
	 * OK
	 */
	200: SchedulerView;
};

export type RunSchedulerResponse =
	RunSchedulerResponses[keyof RunSchedulerResponses];

export type RunSchedulersNearFutureData = {
	body?: never;
	path?: never;
	query?: never;
	url: '/api/run-scheduler/all';
};

export type RunSchedulersNearFutureErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Exception: RequestNotProcessableException
	 */
	422: ErrorResponseDto;
};

export type RunSchedulersNearFutureError =
	RunSchedulersNearFutureErrors[keyof RunSchedulersNearFutureErrors];

export type RunSchedulersNearFutureResponses = {
	/**
	 * OK
	 */
	200: {
		[key: string]: unknown;
	};
};

export type RunSchedulersNearFutureResponse =
	RunSchedulersNearFutureResponses[keyof RunSchedulersNearFutureResponses];

export type GetScheduleData = {
	body?: never;
	path: {
		schedulerId: string;
	};
	query?: never;
	url: '/api/run-scheduler/{schedulerId}';
};

export type GetScheduleErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type GetScheduleError = GetScheduleErrors[keyof GetScheduleErrors];

export type GetScheduleResponses = {
	/**
	 * OK
	 */
	200: SchedulerView;
};

export type GetScheduleResponse =
	GetScheduleResponses[keyof GetScheduleResponses];

export type GetAccountsData = {
	body?: never;
	path?: never;
	query: {
		code: string;
		redirectUri: string;
	};
	url: '/api/truelayer/accounts';
};

export type GetAccountsErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: Exception
	 */
	500: ErrorResponseDto;
};

export type GetAccountsError = GetAccountsErrors[keyof GetAccountsErrors];

export type GetAccountsResponses = {
	/**
	 * OK
	 */
	200: {
		[key: string]: {
			[key: string]: unknown;
		};
	};
};

export type GetAccountsResponse =
	GetAccountsResponses[keyof GetAccountsResponses];

export type CreateSepaPaymentMethodData = {
	body: CreateSepaPaymentRequestDto;
	path?: never;
	query?: never;
	url: '/api/truelayer/createSepaPaymentMethod';
};

export type CreateSepaPaymentMethodErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: Exception
	 */
	500: ErrorResponseDto;
};

export type CreateSepaPaymentMethodError =
	CreateSepaPaymentMethodErrors[keyof CreateSepaPaymentMethodErrors];

export type CreateSepaPaymentMethodResponses = {
	/**
	 * Created
	 */
	201: unknown;
};

export type ChangeEmailAddressData = {
	body: EmailChangeDto;
	path?: never;
	query?: never;
	url: '/api/users/email';
};

export type ChangeEmailAddressErrors = {
	/**
	 * Exception: InvalidEmailAddressException
	 */
	400: ErrorResponseDto;
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
	/**
	 * Exception: EmailChangeAsSocialLoggedInUserException, UserAlreadyExistsException
	 */
	409: ErrorResponseDto;
};

export type ChangeEmailAddressError =
	ChangeEmailAddressErrors[keyof ChangeEmailAddressErrors];

export type ChangeEmailAddressResponses = {
	/**
	 * No Content
	 */
	204: void;
};

export type ChangeEmailAddressResponse =
	ChangeEmailAddressResponses[keyof ChangeEmailAddressResponses];

export type ValidateEmailAddressData = {
	body: EmailChangeCodeDto;
	path?: never;
	query?: never;
	url: '/api/users/email/validate';
};

export type ValidateEmailAddressErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Exception: EmailChangeRequestNotFoundException, EntityNotFoundException
	 */
	404: ErrorResponseDto;
	/**
	 * Exception: EmailChangeAsSocialLoggedInUserException, UserAlreadyExistsException
	 */
	409: ErrorResponseDto;
};

export type ValidateEmailAddressError =
	ValidateEmailAddressErrors[keyof ValidateEmailAddressErrors];

export type ValidateEmailAddressResponses = {
	/**
	 * No Content
	 */
	204: void;
};

export type ValidateEmailAddressResponse =
	ValidateEmailAddressResponses[keyof ValidateEmailAddressResponses];

export type SetLanguageData = {
	body: UpdateLanguageDto;
	path?: never;
	query?: never;
	url: '/api/users/language';
};

export type SetLanguageErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type SetLanguageError = SetLanguageErrors[keyof SetLanguageErrors];

export type SetLanguageResponses = {
	/**
	 * OK
	 */
	200: unknown;
};

export type SpenditTokenData = {
	body: string;
	path?: never;
	query?: never;
	url: '/api/users/spenditToken';
};

export type SpenditTokenErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
	/**
	 * Exception: CommandCurrentRessourceConflictException
	 */
	409: ErrorResponseDto;
};

export type SpenditTokenError = SpenditTokenErrors[keyof SpenditTokenErrors];

export type SpenditTokenResponses = {
	/**
	 * OK
	 */
	200: {
		[key: string]: unknown;
	};
};

export type SpenditTokenResponse =
	SpenditTokenResponses[keyof SpenditTokenResponses];

export type RemoveVoucherData = {
	body?: never;
	path?: never;
	query: {
		voucherCode: string;
	};
	url: '/api/users/vouchers';
};

export type RemoveVoucherErrors = {
	/**
	 * Exception: VoucherAlreadyUsedException
	 */
	400: ErrorResponseDto;
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Exception: NoPermissionException
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type RemoveVoucherError = RemoveVoucherErrors[keyof RemoveVoucherErrors];

export type RemoveVoucherResponses = {
	/**
	 * No Content
	 */
	204: void;
};

export type RemoveVoucherResponse =
	RemoveVoucherResponses[keyof RemoveVoucherResponses];

export type RedeemVoucherData = {
	body: SubscriptionVoucherDto;
	path?: never;
	query?: never;
	url: '/api/users/vouchers';
};

export type RedeemVoucherErrors = {
	/**
	 * Exception: ExpiredVoucherException, VoucherAlreadyUsedException, VoucherReachedLimitException, VoucherSubscriptionIsNotEligibleException
	 */
	400: ErrorResponseDto;
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Exception: NoPermissionException
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type RedeemVoucherError = RedeemVoucherErrors[keyof RedeemVoucherErrors];

export type RedeemVoucherResponses = {
	/**
	 * OK
	 */
	200: SubscriptionVoucherView;
};

export type RedeemVoucherResponse =
	RedeemVoucherResponses[keyof RedeemVoucherResponses];

export type GetActiveVouchersData = {
	body?: never;
	path?: never;
	query?: never;
	url: '/api/users/vouchers/active';
};

export type GetActiveVouchersErrors = {
	/**
	 * Exception: ExpiredVoucherException
	 */
	400: ErrorResponseDto;
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Exception: NoPermissionException
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type GetActiveVouchersError =
	GetActiveVouchersErrors[keyof GetActiveVouchersErrors];

export type GetActiveVouchersResponses = {
	/**
	 * OK
	 */
	200: Array<SubscriptionVoucherView>;
};

export type GetActiveVouchersResponse =
	GetActiveVouchersResponses[keyof GetActiveVouchersResponses];

export type ValidateVoucherData = {
	body: ValidateVoucherDto;
	path?: never;
	query?: never;
	url: '/api/users/vouchers/validate';
};

export type ValidateVoucherErrors = {
	/**
	 * Exception: VoucherAlreadyUsedException, VoucherIsNotEligibleException, VoucherZoneInvalidException
	 */
	400: ErrorResponseDto;
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type ValidateVoucherError =
	ValidateVoucherErrors[keyof ValidateVoucherErrors];

export type ValidateVoucherResponses = {
	/**
	 * OK
	 */
	200: ProdtVoucherView;
};

export type ValidateVoucherResponse =
	ValidateVoucherResponses[keyof ValidateVoucherResponses];

export type GetFeatureFlagV2Data = {
	body?: never;
	path: {
		flag: string;
	};
	query?: never;
	url: '/api/v2/feature-flags/{flag}';
};

export type GetFeatureFlagV2Errors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type GetFeatureFlagV2Error =
	GetFeatureFlagV2Errors[keyof GetFeatureFlagV2Errors];

export type GetFeatureFlagV2Responses = {
	/**
	 * OK
	 */
	200: FeatureFlagView2;
};

export type GetFeatureFlagV2Response =
	GetFeatureFlagV2Responses[keyof GetFeatureFlagV2Responses];

export type PostCapacityCheckV2Data = {
	body: LbodtflexCapacityCheckRequestDto;
	path?: never;
	query?: never;
	url: '/api/v2/router/lbodtflex/capacitycheck';
};

export type PostCapacityCheckV2Errors = {
	/**
	 * Exception: InvalidRequestBodyException
	 */
	400: ErrorResponseDto;
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
	/**
	 * Exception: RequestNotProcessableException
	 */
	422: ErrorResponseDto;
};

export type PostCapacityCheckV2Error =
	PostCapacityCheckV2Errors[keyof PostCapacityCheckV2Errors];

export type PostCapacityCheckV2Responses = {
	/**
	 * OK
	 */
	200: LbodtflexCapacityCheckViewV2;
};

export type PostCapacityCheckV2Response =
	PostCapacityCheckV2Responses[keyof PostCapacityCheckV2Responses];

export type GetCapacityCheckV2Data = {
	body?: never;
	path: {
		capacityCheckId: string;
	};
	query?: never;
	url: '/api/v2/router/lbodtflex/capacitycheck/{capacityCheckId}';
};

export type GetCapacityCheckV2Errors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type GetCapacityCheckV2Error =
	GetCapacityCheckV2Errors[keyof GetCapacityCheckV2Errors];

export type GetCapacityCheckV2Responses = {
	/**
	 * OK
	 */
	200: LbodtflexCapacityCheckViewV2;
};

export type GetCapacityCheckV2Response =
	GetCapacityCheckV2Responses[keyof GetCapacityCheckV2Responses];

export type PatchCapacityCheckData = {
	body: CapacityCheckPatchDto;
	path: {
		capacityCheckId: string;
	};
	query?: never;
	url: '/api/v2/router/lbodtflex/capacitycheck/{capacityCheckId}';
};

export type PatchCapacityCheckErrors = {
	/**
	 * Exception: InvalidRequestBodyException
	 */
	400: ErrorResponseDto;
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
	/**
	 * Exception: RequestNotProcessableException
	 */
	422: ErrorResponseDto;
};

export type PatchCapacityCheckError =
	PatchCapacityCheckErrors[keyof PatchCapacityCheckErrors];

export type PatchCapacityCheckResponses = {
	/**
	 * OK
	 */
	200: LbodtflexCapacityCheckViewV2;
};

export type PatchCapacityCheckResponse =
	PatchCapacityCheckResponses[keyof PatchCapacityCheckResponses];

export type PatchSearchData = {
	body: CapacityCheckPatchDto;
	path: {
		searchId: string;
	};
	query?: never;
	url: '/api/v2/router/prodt/search/{searchId}';
};

export type PatchSearchErrors = {
	/**
	 * Exception: InvalidRequestBodyException
	 */
	400: ErrorResponseDto;
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type PatchSearchError = PatchSearchErrors[keyof PatchSearchErrors];

export type PatchSearchResponses = {
	/**
	 * OK
	 */
	200: PrivateTripSearchView;
};

export type PatchSearchResponse =
	PatchSearchResponses[keyof PatchSearchResponses];

export type CheckVehicleData = {
	body: CheckVehicleDto;
	path?: never;
	query?: never;
	url: '/api/vehicleCheck';
};

export type CheckVehicleErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Exception: NoPermissionException
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type CheckVehicleError = CheckVehicleErrors[keyof CheckVehicleErrors];

export type CheckVehicleResponses = {
	/**
	 * OK
	 */
	200: string;
};

export type CheckVehicleResponse =
	CheckVehicleResponses[keyof CheckVehicleResponses];

export type StartVehicleCheckData = {
	body?: never;
	path: {
		assignmentId: string;
	};
	query?: never;
	url: '/api/vehicleCheck/{assignmentId}/start';
};

export type StartVehicleCheckErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Forbidden
	 */
	403: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
	/**
	 * Exception: CommandNotProcessableException
	 */
	422: ErrorResponseDto;
};

export type StartVehicleCheckError =
	StartVehicleCheckErrors[keyof StartVehicleCheckErrors];

export type StartVehicleCheckResponses = {
	/**
	 * No Content
	 */
	204: void;
};

export type StartVehicleCheckResponse =
	StartVehicleCheckResponses[keyof StartVehicleCheckResponses];

export type WhoAmIData = {
	body?: never;
	path?: never;
	query?: never;
	url: '/api/whoami';
};

export type WhoAmIErrors = {
	/**
	 * Unauthorized
	 */
	401: ErrorResponseDto;
	/**
	 * Exception: EntityNotFoundException
	 */
	404: ErrorResponseDto;
};

export type WhoAmIError = WhoAmIErrors[keyof WhoAmIErrors];

export type WhoAmIResponses = {
	/**
	 * OK
	 */
	200: WhoAmIView;
};

export type WhoAmIResponse = WhoAmIResponses[keyof WhoAmIResponses];
